<template>
  <div>
    <b-row class="m-0 justify-content-center" v-if="restaurant">
      <transition name="fade" mode="out-in">
      <div style="width: 1600px; max-width: 100%; " v-show="!expanded">
        <b-row class="m-0 justify-content-center" >

          <b-col lg="4" class="p-0 pr-lg-3 d-none d-lg-flex w-100 h-100" v-if="!isMobile" style="max-height: 100vh; overflow-y: auto; position: sticky; top: 0px;">
            <div class="ml-lg-5 mt-4 mb-5 p-3 shadow bg-white rounded w-100 h-100" style="margin-top: 100px !important">
              
              <b-row class="m-0 justify-content-center">
                <b-img-lazy :src="getImages(restaurant.img.image)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>  
              </b-row>
              
              <div v-if="!restaurant.event">

                <b-row class="m-0 mb-2 justify-content-center" v-if="restaurant.delivery">
                  <div>
                    <h5>Abholen oder liefern?</h5>
                    <b-row class="m-0 mt-3 justify-content-between">
                      <b-button :disabled="restaurant.delivery && !checkDeliveryTimes()" :variant="delivery === true ? 'dark' : 'outline-dark'" @click="delivery = true">liefern</b-button>
                      <b-button :variant="delivery === false ? 'dark' : 'outline-dark'" @click="delivery = false">abholen</b-button>
                    </b-row>
                  </div>
                </b-row>
                <div v-if="restaurant.delivery && !checkDeliveryTimes()" >
                  <p class="text-danger text-center">Zur Zeit keine Lieferung möglich!
                  </p>
                </div>
                <div class="m-0 mt-4" v-if="delivery === true">
                  <p class="text-center" v-if="adressData_delivery">{{ adressData_delivery.locality }}</p>
                  <b-row class="m-0 justify-content-center">
                    <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse ändern</b-button>
                  </b-row>
                </div>
                <div v-if="restaurant.delivery && delivery === true">
                  <b-row class="m-0 mt-4 mb-2 justify-content-center" >
                    <p class="m-0 text-center mb-2" >Durchschnittliche Lieferzeit: <br> <span class="text-info"> {{ restaurant.actual_delivery_time }}</span> min ab Bestellbestätigung</p>
                  </b-row>
                </div>
                
                <b-row class="m-0 mt-4 mb-2 justify-content-center" v-if="!restaurant.delivery || (restaurant.delivery && delivery === false) || !checkDeliveryTimes()">
                  <h5 class="m-0 text-center" :class="!selectedTime ? 'text-danger' : ''">Abholzeit:</h5>
                </b-row>
                <b-row class="m-0 mb-3 justify-content-center">
                  <p class="m-0 text-center" v-if="selectedTime && selectedTime != 'over'">{{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} Uhr</p>
                  <p class="m-0 text-center text-danger" v-if="selectedTime == 'over' && warning">Die gewählte Zeit ist nicht mehr verfügbar</p>
                </b-row>
                
                <b-row class="justify-content-around mb-4" v-if="slots && (restaurant.delivery && (delivery === false)) || !restaurant.delivery || !checkDeliveryTimes()">
                  <b-button v-if="slots[0] && !selectedDate" class="m-0" :class="slots[0].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[0].slots <= 0" :variant="preTime.time == slots[0].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[0], slots[0])">{{ slots[0].time }}</b-button>
                  <b-button v-if="slots[1] && !selectedDate" class="m-0" :class="slots[1].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[1].slots <= 0" :variant="preTime.time == slots[1].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[1], slots[1])">{{ slots[1].time }}</b-button>
                  <b-button v-if="slots[2] && !selectedDate" class="m-0" :class="slots[2].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[2].slots <= 0" :variant="preTime.time == slots[2].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[2], slots[2])">{{ slots[2].time }}</b-button>
                  <b-button v-show="slots.length > 0 && !selectedDate" class="m-0" :variant="getMoreVariant()" @click="timeModal = true">später</b-button>
                  <b-button v-show="slots.length > 0 && selectedDate" class="m-0" :variant="getMoreVariant()" @click="timeModal = true">andere Zeit auswählen</b-button>
                  <b-button v-show="slots.length == 0" class="m-0" disabled variant="dark">heute keine Abholung möglich</b-button>
                  <b-button v-show="slots.length == 0" class="m-0 mt-2" :variant="preTime.time ? 'dark' : 'outline-dark'" @click="timeModal = true">andere Zeit auswählen</b-button>
                </b-row>
                
                <b-row class="m-0 mb-2 justify-content-center">
                  <h4>Warenkorb</h4>
                </b-row>
                <p class="text-center mt-3" v-show="cart.length == 0">Wähle leckere Gerichte aus der Karte und bestelle Dein Menü.</p>
                
                <div class="my-2" v-for="(item, index) in cart" :key="item.index">
                  <cart-item :cartItem="item" :cart="cart" :index="index"></cart-item>
                </div>
                
                <hr class="mt-2">
                
                <b-row class="m-0 justify-content-between">
                  <p>Gesamtpreis:</p>
                  <p>{{ totalPrice }}€</p>
                </b-row>

                <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue? 'text-success' : 'text-danger'">
                  <small>Mindestbestellwert:</small>
                  <small>{{ minDeliveryValue }}€</small>
                </b-row>

                <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue? 'text-success' : 'text-danger'">
                  <small>Liefergebühr:</small>
                  <small>{{ deliveryFee }}€</small>
                </b-row>

                <div v-if="!minDeliveryValue && delivery" class="text-danger justify-content-center">
                  <p class="text-center">An diese Adresse ist keine Lieferung möglich!</p>
                  <b-row class="m-0 justify-content-center">
                    <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse korrigieren</b-button>
                  </b-row>
                </div>

                <div class="order-button shadow " :class="cart.length > 0 && ((selectedTime && selectedTime != 'over') || (delivery && parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue))? 'linear-warning hover' : 'bg-secondary forbidden' " @click="openOrderModal()">
                  <b-row class="m-0 justify-content-center mt-2 ">
                    <h4 v-show="cart.length == 0" class="mt-2 pt-1 text-center">Gerichte auswählen</h4>
                    <h4 v-show="(!selectedTime || selectedTime == 'over') && !delivery" class="mt-2 pt-1 text-center">Abholzeit auswählen</h4> 
                    <h4 v-show="cart.length > 0 && ((selectedTime && selectedTime != 'over') || delivery)" class="mt-2 pt-1 text-center">{{ cart.length > 0 && ((selectedTime && selectedTime != 'over') || delivery)? 'Bestellen' : ''}}</h4>
                  </b-row>
                </div>
                <div class="mt-4">
                  <hr>
                  <p>Zahlungsmethoden {{ delivery ? 'an deiner Haustüre' : 'vor Ort' }}:</p>
                  <div class="my-2 pt-0" v-show="restaurant.payment_methods.cash">
                    <font-awesome-icon class="text-success" icon="money-bill-wave" /> Bar
                  </div>
                  <div class="my-2" v-show="restaurant.payment_methods.card">
                    <font-awesome-icon class="text-dark" icon="credit-card" /> EC Karte
                  </div>
                  <div class="my-2" v-show="restaurant.payment_methods.paypal">
                    <font-awesome-icon class="text-primary" :icon="['fab', 'cc-paypal']"/> PayPal
                  </div>
                  <div class="my-2" v-show="restaurant.payment_methods.credit_card">
                    <font-awesome-icon class="text-dark" :icon="['fab', 'cc-visa']"/> Kreditkarte
                  </div>
                </div>
                
                <div v-show="!restaurant.enable_online_order">
                  <hr>
                  <small> <strong>Hinweis:</strong> {{ restaurant.title }} bietet aktuell nur eine telefonische Bestellung an.</small>
                </div>

              </div>
              <!-- Event Modal -->
              <div v-else>
                <div class="my-2" v-for="(item) in cart" :key="item.index">
                  <p>{{item.title}}</p>
                </div>
                
                <hr class="mt-2">
                
                <b-row class="m-0 justify-content-between">
                  <p>Gesamtpreis:</p>
                  <p>{{ totalPrice }}€</p>
                </b-row>

                <div class="order-button shadow " :class="cart.length > 0 ? 'linear-warning hover' : 'bg-secondary forbidden' " @click="openOrderModalEvent()">
                  <b-row class="m-0 justify-content-center mt-2 ">
                    <h4 v-show="cart.length == 0" class="mt-2 pt-1 text-center">Produkt auswählen</h4>
                    <h4 v-show="cart.length > 0 " class="mt-2 pt-1 text-center">{{ cart.length > 0 ? 'Bestellen' : ''}}</h4>
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>

          <b-col cols="12" lg="8" class="p-0 h-100">
            <div class="mt-lg-4 mr-lg-5 shadow rounded" style="margin-top: 100px !important">

              <div class="p-3 mt-3 bg-white">
                <b-row class="m-0 justify-content-center d-lg-none">
                <b-img-lazy :src="getImages(restaurant.img.image)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>  
                </b-row>
                <h3 class="text-center my-2">{{ restaurant.title}}</h3>
                <h5 class="text-center">{{ restaurant.description}}</h5>
                <p class="text-center my-2">{{ restaurant.adress.street}}, {{ restaurant.adress.city}}</p>
                <p class="text-center my-2" v-if="getOpeningTimes().first || getOpeningTimes().second"> <span> {{ getOpeningTimes().first }} </span> <span class="ml-3"> {{ getOpeningTimes().second }} </span></p>
                <p class="text-center my-2" v-else>heute geschlossen</p>
                <b-row class="m-0 justify-content-center">
                  <div @click="openRatingModal()" style="max-width: 400px">
                    <b-form-rating  readonly class="hover text-center" size="md" :no-border="true" variant="warning" v-model="getRating"></b-form-rating>
                  </div>
                  <p v-if="restaurant.ratings" class="m-0 mt-2">({{restaurant.ratings.length}})</p>
                </b-row>
                <h4 class="text-center mt-3 mb-0">Kategorien</h4>
              </div>

              <div style="position: sticky; top: 0; left: 0; right: 0; z-index: 3001 !important;" v-if="!isMobile">
                <div style="height: 85px; z-index: 3002;" class="shadow linear-warning scroll-container-categories" v-dragscroll id="scroll-container-categories">
                  <div class="scroll-item" @click="scrollToCategory(category._id)" :id="'item-'+category._id" v-for="category in restaurant.categories.filter(category => restaurant.menus.find(menu => menu.category._id == category._id))" :key="category.index">
                  {{ category.title }}
                  </div>
                </div>
              </div>

              <div style="position: sticky; top: 0; left: 0; right: 0; z-index: 3001 !important;" v-else>
                <div style="height: 85px; z-index: 3002;" class="shadow linear-warning scroll-container-categories" id="scroll-container-categories">
                  <div class="scroll-item" @click="scrollToCategory(category._id)" :id="'item-'+category._id" v-for="category in restaurant.categories.filter(category => restaurant.menus.find(menu => menu.category._id == category._id))" :key="category.index">
                  {{ category.title }}
                  </div>
                </div>
              </div>

              <div class="p-3 bg-white">
                <h3 class="text-center my-2">Speisekarte</h3>
                <div style="z-index: 1000 !important" class="pt-2">
                  <div v-for="(category) in restaurant.categories.filter(category => restaurant.menus.find(menu => menu.category._id == category._id))" :key="category._id" >
                    <h3 class="text-left ml-1 my-3" :id="category._id">{{ category.title }}</h3>
                    <h4 class="text-left ml-1 my-3" >{{ category.description }}</h4>
                    <div v-for="menuitem in restaurant.menus.filter(menu => menu.category._id == category._id)" :key="menuitem._id">
                      <menu-item @addToCart="addToCart" :menuItem="menuitem"></menu-item>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </b-col>

        </b-row>
      </div>
      </transition>
    </b-row>
    
    <b-row class="m-0 justify-content-center" v-if="!restaurant && !loadingRestaurant">
      <div style="width: 1600px; max-width: 100%; margin-top: 100px !important" >
        <b-row class="m-0 justify-content-center">
          <b-col cols="12" lg="12" style="z-index: 1000 !important">
            <div class="mt-3 shadow bg-white rounded p-3">
              <b-row class="m-0 my-5 justify-content-center">
                <b-img-lazy :src="require(`@/assets/images/undraw_searching.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>  
              </b-row>
              <h3 class="text-center my-2 mb-5">Dieses Restaurant gibt es scheinbar nicht, oder es ist gerade offline...</h3>
            </div>
          </b-col>      
        </b-row>
      </div>
    </b-row>

    <div style="height: 60vh; max-height: 60vh; overflow-y: auto; z-index: 1000 !important" class="pt-2" v-if="loadingRestaurant">
      <loading-overlay :text="'lade Restaurant...'" />
    </div>
    
    <Footer class="my-5" style="margin-bottom: 100px !important"></Footer>

    <!-- <b-modal id="infoModal" v-model="infoModal" hide-footer hide-header v-if="activeMenu">
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >Zusatzstoffe und Allergene</h4>
          <font-awesome-icon @click="infoModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <div class="m-3">

          <div v-if="activeMenu.additives">
            <h5 v-show="activeMenu.additives.length > 0" class="text-left ml-3">Zusatzstoffe:</h5>
            <ul class="m-0" v-for="additive in activeMenu.additives" :key="additive.index">
                <li class="m-0">{{ additive.description }}</li>
            </ul>
          </div>

          <div v-if="activeMenu.allergens">
            <h5 v-show="activeMenu.allergens.length > 0" class="mt-3 text-left ml-3">Allergene:</h5>
            <ul class="m-0" v-for="allergen in activeMenu.allergens" :key="allergen.index">
              <li class="m-0 mb-2">{{ allergen.title }} {{ allergen.description }}</li>
            </ul>
          </div>

          <div v-if="activeMenu.allergens && activeMenu.additives">
            <h5 v-show="activeMenu.allergens.length == 0 && activeMenu.additives.length == 0" class="mt-3 text-left">Hinweis:</h5>
            <small>Informationen zu Zusatzstoffen und Allergenen liegen in der Regel in den Restaurants aus.</small>
          </div>

          <div class="py-3">
           <small >Es kann vorkommen, dass die angezeigten Informationen unvollständig sind.</small>
           <small > Bitte wende dich direkt an das jeweilige Restaurant, wenn Allergien oder Unverträglichkeiten vorliegen.</small>
          </div>
        </div>

      </div>
    </b-modal> -->

    <div v-if="cart">
      <b-modal id="infoModal" class="" no-close-on-backdrop size="md" v-model="orderModal" hide-footer hide-header v-if="cart.length > 0 && restaurant && (selectedTime || delivery) && !isMobile && !restaurant.event" :key="order.dsgvo_accepted.length">
        <div class="bg-white" style="border-radius: 10px; transition: all .5s;" >
          <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
            <h4 class="ml-2 text-center text-dark" >Deine Bestellung</h4>
            <font-awesome-icon v-show="!(orderState.confirmation_required || orderState.verified === false && !orderState.enable_refresh)" @click="orderModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
          </b-row>
          <div class="p-3 rounded" v-show="!orderActive">
            
            <b-row class="m-0 mb-5 justify-content-center">
              <b-img-lazy class="mt-3" :src="require(`@/assets/images/undraw_shopping.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>              
            </b-row>
            <b-row class="m-0 my-4 justify-content-between">
              <h5 class="m-0" v-show="selectedTime">{{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5>
              <h5 class="m-0 text-center text-danger" v-show="selectedTime == 'over' && warning">Die gewählte Zeit ist nicht mehr verfügbar</h5>
            </b-row>
            
            <div class="my-3" v-for="(item) in cart" :key="item.index">

              <cart-item :cartItem="item" :cart="cart" :index="index" :checkOrder="true"></cart-item>

            </div>
            
            <hr class="m-2">
            
            <b-row class="m-0 justify-content-between w-100">
              <h3>Gesamtpreis:</h3>
              <h3>{{ totalPrice }}€</h3>
            </b-row>
            
            <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue ? 'text-success' : 'text-danger'">
              <small>Mindestbestellwert:</small>
              <small>{{ minDeliveryValue }}€</small>
            </b-row>
            <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue? 'text-success' : 'text-danger'">
              <small>Liefergebühr:</small>
              <small>{{ deliveryFee }}€</small>
            </b-row>
            <div v-if="!minDeliveryValue && delivery" class="text-danger justify-content-center">
              <p class="text-center">An diese Adresse ist keine Lieferung möglich!</p>
              <b-row class="m-0 justify-content-center">
                <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse korrigieren</b-button>
              </b-row>
            </div>

            <div v-show="restaurant.enable_online_order"> 

              <div class="order-button shadow linear-warning hover" @click="orderActive = true">
                <b-row class="m-0 justify-content-center mt-2 ">
                  <h5 class="mt-2 pt-1 text-center">Bestellung online abschließen</h5> 
                </b-row>
              </div>
              
              <p class="text-center mt-3">Oder per Telefon bestellen:</p>
            </div>
            
            <div class="w-100 mt-3" >
              <hr>
              <div class="order-button shadow d-block d-md-none" :class="cart.length > 0 ? 'linear-warning hover' : 'bg-secondary forbidden' " @click="orderModal = true">

                <b-row class="m-0 justify-content-center mt-2 hover">
                  <a :href="'tel:'+restaurant.contact.phone"><h4 class="mt-2 pt-1">{{ restaurant.title }} jetzt anrufen</h4> </a> 
                </b-row>
              </div>
              <div class="d-none d-lg-block">
                <div>
                  <p class="text-center">Telefonnummer:</p>
                </div>
                
                <div>
                  <h1 class="text-center">{{ restaurant.contact.phone }}</h1>
                </div>
              </div>
              
              
              <div v-show="!restaurant.enable_online_order">
                <hr>
                <small> <strong>Hinweis:</strong> {{ restaurant.title }} bietet aktuell nur eine telefonische Bestellung an.</small>
              </div>
            </div>
            <div v-show="!restaurant.enable_online_order" class="d-block d-md-none">
              <hr>
              <small> <strong>Empfehlung:</strong> Stelle dein Telefon auf Lautsprecher, so kannst du die Bestellung ganz einfach hier ablesen.</small>
            </div>
          </div>

          <div class="p-3 rounded" v-show="orderActive && restaurant.enable_online_order ">
            <div v-show="!loggedIn && !orderState.sms_sent && !(orderState.verified === false)">
              <b-row class="m-0 justify-content-between">
                <h3 class="text-center text-dark">{{ cart.length }} Speisen - {{ totalPrice }} €</h3>
              </b-row>
              <b-row class="m-0 mb-3 justify-content-between">
                <h5 class="m-0" v-show="selectedTime">Abholung: {{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5> 
              </b-row>
              <b-tabs content-class="mt-3" justified v-model="tabIndex">
                <b-tab title="Einloggen" disabled>
                  <p class="text-center m-0 mt-3">Logge dich mit deiner E-Mail-Adresse und deinem Passwort ein:</p>

                  <b-form class="mt-3" @submit.prevent="submitLogin()">

                    <b-form-group
                    label="Deine E-Mail-Adresse:"
                    >
                      <b-form-input
                        :state="form.email && !authError? true : false"
                        v-model="form.email"
                        id="email"
                        type="email"
                        required
                      ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ authMessage }}
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                      label="Dein Passwort:"
                    >
                      <b-form-input
                        id="password"
                        :state="form.password && !authError? true : false"
                        v-model="form.password"
                        type="password"
                        required
                      ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ authMessage }}
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <p class="text-center custom-nav m-0 my-3" @click="$router.push('/passwordforgot').catch(err => {})">Passwort vergessen?</p>
                    
                    <b-button type="submit" style="width: 100%" size="md" variant="dark">Anmelden</b-button>

                    <!-- <p class="text-center m-0 my-3" >Neu hier?</p>
                    
                    <b-button style="width: 100%" size="md" variant="dark" @click="registerActive = true">Jetzt Konto anlegen</b-button> -->

                  </b-form>
                </b-tab>
                <b-tab title="Als Gast bestellen" active>
                  <b-form></b-form>
                    <b-form-group
                    label="Vorname:"
                    >
                      <b-form-input
                        name="firstname"
                        :state="order.firstname ? true : false"
                        v-model="order.firstname"
                        type="text"
                        placeholder="Vorname eingeben..."
                        :required="tabIndex == 1"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                    label="Nachname:"
                    >
                      <b-form-input
                        name="lastname"
                        :state="order.lastname ? true : false"
                        v-model="order.lastname"
                        type="text"
                        placeholder="Nachname eingeben..."
                        :required="tabIndex == 1"
                      ></b-form-input>
                    </b-form-group>
                    <div v-if="delivery">
                      <p class="m-0 my-2">Lieferadresse:</p>
                      <p class="m-0 ">{{ adressData_delivery.locality }}</p>
                      <b-button class="my-2" size="sm" @click="deliveryModal = true">Lieferadresse korrigieren</b-button>
                    </div>
                    <b-form-group
                    label="Mobilnummer:"
                    description="Das Restaurant benötigt deine Mobilnummer für eventuelle Rückfragen und zur Bestätigung der Bestellung. An diese Nummer wird ein Code per SMS gesendet."
                    > 
                      <b-row>
                        <b-col cols="2" class="pr-0">
                          <b-form-input

                            v-model="preNumber"
                            type="text"
                            disabled
                            placeholder="+49"
                            :required="tabIndex == 1"
                          ></b-form-input>
                        </b-col>
                        <b-col cols="10" class="pl-1">
                          <b-form-input
                            name="phone"
                            :state="!order.phone || (orderState.order_sent && !orderState.sms_sent) || order.phone.length < 10 ? false : true"
                            v-model="order.phone"
                            type="text"
                            placeholder="Mobilnummer eingeben..."
                            :required="tabIndex == 1"
                          ></b-form-input>
                          
                        </b-col>
                      </b-row>
                      <b-form-invalid-feedback :state="orderState.order_sent && !orderState.sms_sent ? false : true">
                        An die Angegebene Mobilnummer konnte keine SMS gesendet werden, bitte überprüfe die Richtigkeit der Nummer.
                      </b-form-invalid-feedback>
                      
                    </b-form-group>

                    <div class="mt-3" v-show="!orderState.confirmation_required && !orderState.sms_sent && !(orderState.verified === false)"> 
                      <b-form-checkbox
                        class="mt-3"
                        v-model="order.dsgvo_accepted"
                        name="checkbox-dsvgo"
                        required
                      >
                        Ich habe die <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a> gelesen und Stimme zu. {{ delivery ? '' : 'Außerdem bestätige ich, die bestellte Ware abzuholen und im Restaurant zu bezahlen.'}}
                      </b-form-checkbox>
                      <div class="mt-3" v-if="delivery && parseFloat(totalPrice) < minDeliveryValue"> 
                        <p class="text-center text-danger">Mindestbestellwert nicht erreicht!</p>
                      </div>
                      <div class="mt-3" v-if="delivery && !minDeliveryValue">
                        <p class="text-center text-danger">An diese Adresse ist keine Lieferung möglich!</p>
                      </div>
                      <div class="mt-3 order-button shadow" :class="((delivery && parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue) || !delivery) && order.dsgvo_accepted && ((tabIndex == 0 && (order.email && order.password)) || (tabIndex == 1 && (order.firstname && order.lastname && order.phone)))? 'linear-warning hover' : 'bg-secondary forbidden' ">
                        <b-row class="m-0 justify-content-center mt-2 ">
                          <h5 v-show="!updating" class="mt-2 pt-1 text-center" @click="postOrder()">Zahlungspflichtig bestellen</h5>
                          <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
                        </b-row>
                      </div>
                    
                    </div>

                </b-tab>
              </b-tabs>
              
            </div>


            <div v-show="orderState.confirmation_required || orderState.verified === false && !orderState.enable_refresh">
              <h3 class="text-center mb-5">Wir haben Dir einen Bestätigungscode per SMS gesendet.</h3>
              <p class="text-center">Dieser Code ist 5 Minuten lang gültig, danach wird deine Bestellung automatisch storniert.</p>
              <h4 class="text-center">Bitte gib den Code ein:</h4>
              <b-row class="m-0 my-5 justify-content-center">
                <p v-show="orderState.verified === false" class="text-center text-danger">{{ orderState.message }}</p>
                <Sms v-model="securityCode"></Sms>
              </b-row>
              <p class="text-center custom-nav" @click="resendCode">Code <span v-show="timer > 0">in {{timer}} Sekunden</span> erneut schicken</p>
              <p class="text-center">SMS kommt nicht an? <span class="custom-nav hover text-info" @click="resetOrder()">Bestellung {{ timer > 0 ? 'in '+timer+' Sekunden' : '' }} neu aufgeben.</span></p>
              <div class="order-button shadow" @click="confirmOrder()" :class="securityCode.length == 6 ? 'linear-warning hover' : 'bg-secondary forbidden'">
                <b-row class="m-0 justify-content-center mt-2 " >
                  <h5 v-show="!updating" class="mt-2 pt-1 text-center" >Bestellung bestätigen</h5>
                  <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
                </b-row>
              </div>
            </div>
            <div v-show="orderState.enable_refresh">
              <h3 class="text-center text-danger my-3"> 
                Die Bestellung wurde storniert und ist ungültig.
              </h3>
              <p class="text-center my-3">Der Code ist leider nicht mehr gültig, die Bestellung wurde storniert.</p>
              <div class="order-button shadow linear-warning hover" @click="resetOrder()">
                <b-row class="m-0 justify-content-center mt-2 " >
                  <h5 v-show="!updating" class="mt-2 pt-1 text-center" >Erneut bestellen</h5>
                  <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <div v-if="restaurant">
      <b-modal id="infoModal" class="" no-close-on-backdrop size="md" v-model="orderModalEvent" hide-footer hide-header v-if="cart.length > 0 && restaurant.event && !isMobile" :key="order.dsgvo_accepted.length">
        <div class="bg-white" style="border-radius: 10px; transition: all .5s;" >
          <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
            <h4 class="ml-2 text-center text-dark" >Deine Bestellung</h4>
            <font-awesome-icon v-show="!(orderState.confirmation_required || orderState.verified === false && !orderState.enable_refresh)" @click="orderModalEvent = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
          </b-row>
          <div class="p-3 rounded" v-show="!orderActive">
            
            <b-row class="m-0 mb-5 justify-content-center">
              <b-img-lazy class="mt-3" :src="require(`@/assets/images/undraw_shopping.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>              
            </b-row>
            <b-row class="m-0 my-4 justify-content-between">
              <h5 class="m-0" v-show="selectedTime">{{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5>
              <h5 class="m-0 text-center text-danger" v-show="selectedTime == 'over' && warning">Die gewählte Zeit ist nicht mehr verfügbar</h5>
            </b-row>
            
            <div class="my-3" v-for="(item) in cart" :key="item.index">
              <p class="text-center"> {{ item.title }} </p>
            </div>
            
            <hr class="m-2">
            
            <b-row class="m-0 justify-content-between w-100">
              <h3>Gesamtpreis:</h3>
              <h3>{{ totalPrice }}€</h3>
            </b-row>

            <div v-show="restaurant.enable_online_order"> 

              <div class="order-button shadow linear-warning hover" @click="orderActive = true">
                <b-row class="m-0 justify-content-center mt-2 ">
                  <h5 class="mt-2 pt-1 text-center">Bestellung online abschließen</h5> 
                </b-row>
              </div>
            </div>
          </div>

          <div class="p-3 rounded" v-show="orderActive && restaurant.enable_online_order ">
            <div v-show="!loggedIn && !orderState.sms_sent && !(orderState.verified === false)">
             
                    <b-form-group
                    label="Vorname:"
                    >
                      <b-form-input
                        name="firstname"
                        :state="order.firstname && !orderState.double_order ? true : false"
                        v-model="order.firstname"
                        type="text"
                        placeholder="Vorname eingeben..."
                        required
                      ></b-form-input>
                      <b-form-invalid-feedback :state="orderState.double_order == false ? true : false">
                        <div v-if="orderState.double_order == true">
                          Für den angegebenen Haushalt wurde bereits eine Bestellung getätigt!
                        </div>                        
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                    label="Nachname:"
                    >
                      <b-form-input
                        name="lastname"
                        :state="order.lastname && !orderState.double_order ? true : false"
                        v-model="order.lastname"
                        type="text"
                        placeholder="Nachname eingeben..."
                        required
                      ></b-form-input>
                      <b-form-invalid-feedback :state="orderState.double_order == false ? true : false">
                        <div v-if="orderState.double_order == true">
                          Für den angegebenen Haushalt wurde bereits eine Bestellung getätigt!
                        </div>                        
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                    label="Straße und Hausnummer:"
                    >
                      <b-form-input
                        name="street"
                        :state="eventOrder.street && !orderState.double_order ? true : false"
                        v-model="eventOrder.street"
                        type="text"
                        placeholder="Straße und Hausnummer eingeben..."
                        required
                      ></b-form-input>
                      <b-form-invalid-feedback :state="orderState.double_order == false ? true : false">
                        <div v-if="orderState.double_order == true">
                          Für den angegebenen Haushalt wurde bereits eine Bestellung getätigt!
                        </div>                        
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                    label="Postleitzahl:"
                    >
                      <b-form-input
                        name="zipcode"
                        :state="eventOrder.zipcode ? true : false"
                        v-model="eventOrder.zipcode"
                        type="text"
                        disabled
                        placeholder="Postleitzahl eingeben..."
                        required
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                    label="Stadt / Ortsteil:"
                    >
                      <b-form-select :state="eventOrder.city ? true : false" v-model="eventOrder.city" :options="cityOptions"></b-form-select>
                    </b-form-group>
                    <b-form-group
                    label="Mobilnummer:"
                    description="Wir benötigen deine Mobilnummer für eventuelle Rückfragen und zur Bestätigung der Bestellung. An diese Nummer wird ein Code per SMS gesendet."
                    > 
                      <b-row>
                        <b-col cols="2" class="pr-0">
                          <b-form-input
                            v-model="preNumber"
                            type="text"
                            disabled
                            placeholder="+49"
                            required
                          ></b-form-input>
                        </b-col>
                        <b-col cols="10" class="pl-1">
                          <b-form-input
                            name="phone"
                            :state="!order.phone || (orderState.order_sent && !orderState.sms_sent) || order.phone.length < 10 ? false : true"
                            v-model="order.phone"
                            type="text"
                            placeholder="Mobilnummer eingeben..."
                            required
                          ></b-form-input>
                          
                        </b-col>
                      </b-row>
                      <b-form-invalid-feedback :state="orderState.order_sent && !orderState.sms_sent ? false : true">
                        An die Angegebene Mobilnummer konnte keine SMS gesendet werden, bitte überprüfe die Richtigkeit der Nummer.
                      </b-form-invalid-feedback>
                      
                    </b-form-group>

                    <div class="mt-3" v-show="!orderState.confirmation_required && !orderState.sms_sent && !(orderState.verified === false)"> 
                      <b-form-checkbox
                        class="mt-3"
                        v-model="order.dsgvo_accepted"
                        name="checkbox-dsvgo"
                        required
                      >
                        Ich habe die <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a> gelesen und Stimme zu.
                      </b-form-checkbox>
                      <b-form-checkbox
                        class="mt-3"
                        v-model="order.over_sixteen"
                        name="checkbox-dsvgo"
                        required
                      >
                        Ich bin mindestens 16 Jahre alt.
                      </b-form-checkbox>
                    
                      <div class="mt-3 order-button shadow" :class="order.dsgvo_accepted && order.over_sixteen && order.firstname && order.lastname && order.phone && eventOrder.zipcode && eventOrder.city && eventOrder.street ? 'linear-warning hover' : 'bg-secondary forbidden' ">
                        <b-row class="m-0 justify-content-center mt-2 ">
                          <h5 v-show="!updating" class="mt-2 pt-1 text-center" @click="postOrderEvent()">Gratis bestellen</h5>
                          <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
                        </b-row>
                      </div>
                    
                    </div>

              
            </div>


            <div v-show="orderState.confirmation_required || orderState.verified === false && !orderState.enable_refresh">
              <h3 class="text-center mb-5">Wir haben Dir einen Bestätigungscode per SMS gesendet.</h3>
              <p class="text-center">Dieser Code ist 5 Minuten lang gültig, danach wird deine Bestellung automatisch storniert.</p>
              <h4 class="text-center">Bitte gib den Code ein:</h4>
              <b-row class="m-0 my-5 justify-content-center">
                <p v-show="orderState.verified === false" class="text-center text-danger">{{ orderState.message }}</p>
                <Sms v-model="securityCode"></Sms>
              </b-row>
              <p class="text-center custom-nav" @click="resendCode">Code <span v-show="timer > 0">in {{timer}} Sekunden</span> erneut schicken</p>
              <p class="text-center">SMS kommt nicht an? <span class="custom-nav hover text-info" @click="resetOrder()">Bestellung {{ timer > 0 ? 'in '+timer+' Sekunden' : '' }} neu aufgeben.</span></p>
              <div class="order-button shadow" @click="confirmOrder()" :class="securityCode.length == 6 ? 'linear-warning hover' : 'bg-secondary forbidden'">
                <b-row class="m-0 justify-content-center mt-2 " >
                  <h5 v-show="!updating" class="mt-2 pt-1 text-center" >Bestellung bestätigen</h5>
                  <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
                </b-row>
              </div>
            </div>
            <div v-show="orderState.enable_refresh">
              <h3 class="text-center text-danger my-3"> 
                Die Bestellung wurde storniert und ist ungültig.
              </h3>
              <p class="text-center my-3">Der Code ist leider nicht mehr gültig, die Bestellung wurde storniert.</p>
              <div class="order-button shadow linear-warning hover" @click="resetOrder()">
                <b-row class="m-0 justify-content-center mt-2 " >
                  <h5 v-show="!updating" class="mt-2 pt-1 text-center" >Erneut bestellen</h5>
                  <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <b-modal id="infoModal" size="md" v-model="cartModal"  hide-footer hide-header v-if="restaurant && !isMobile">
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >Dein Warenkorb</h4>
          <font-awesome-icon @click="cartModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
            <div class="ml-lg-5 mt-4 p-3 shadow bg-white rounded">
              
              <b-row class="m-0 mb-5 justify-content-center">
                <b-img-lazy class="mt-3" :src="require(`@/assets/images/undraw_shopping.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>  

                <h4>Warenkorb</h4>

              </b-row>
              <b-row class="m-0 justify-content-between">
                <p class="m-0 mb-3">Abholzeit wählen:</p>
              </b-row>
              <b-row class="justify-content-around" v-if="slots">
                <b-button v-if="slots[0] && !selectedDate" class="m-0" :class="slots[0].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[0].slots <= 0" :variant="preTime.time == slots[0].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[0], slots[0])">{{ slots[0].time }}</b-button>
                <b-button v-if="slots[1] && !selectedDate" class="m-0" :class="slots[1].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[1].slots <= 0" :variant="preTime.time == slots[1].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[1], slots[1])">{{ slots[1].time }}</b-button>
                <b-button v-if="slots[2] && !selectedDate" class="m-0" :class="slots[2].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[2].slots <= 0" :variant="preTime.time == slots[2].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[2], slots[2])">{{ slots[2].time }}</b-button>
                <b-button v-show="slots.length > 0" class="m-0" :variant="getMoreVariant()" @click="timeModal = true">später</b-button>
                <b-button v-show="slots.length == 0" class="m-0" disabled variant="dark">heute keine Abholung möglich</b-button>
                <b-button v-show="slots.length == 0" class="m-0" :variant="preTime.time ? 'dark' : 'outline-dark'" @click="timeModal = true">andere</b-button>
              </b-row>
              <b-row class="m-0 my-4 justify-content-between">
                <h5 class="m-0" v-if="selectedTime">{{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5>
                <h5 class="m-0 text-center text-danger" v-if="selectedTime == 'over' && warning">Die gewählte Zeit ist nicht mehr verfügbar</h5>
              </b-row>
              <p class="text-center mt-4" v-show="cart.length == 0">Wähle leckere Gerichte aus der Karte und bestelle Dein Menü.</p>
              
              <div class="my-3" v-for="(item, index) in cart" :key="item.index">
                <b-row class="m-0 p-0 justify-content-between" >
                  <p class="m-0" :key="item.amount">{{ item.amount }}x 
                    <font-awesome-icon @click="subItem(item, index)" style="z-index: 2000" class="ml-2 hover h5 m-0 text-danger" :icon="['fas', 'minus-square']"/>
                    <font-awesome-icon @click="addItem(item)" style="z-index: 2000" class="ml-3 hover h5 m-0 text-success" :icon="['fas', 'plus-square']"/>
                  </p>
                  <p class="m-0">{{ item.title }}</p>
                  <p class="m-0">{{ getExtrasPrice(item) }}€</p>
                </b-row>

                <b-row class="m-0 justify-content-center mt-2 mb-4" v-b-toggle="'item-'+item._id+index">
                  <font-awesome-icon class="when-closed" style="font-size: 20px; cursor: pointer" :icon="['fas', 'chevron-down']"/>
                  <font-awesome-icon class="when-open" style="font-size: 20px; cursor: pointer" :icon="['fas', 'chevron-up']"/>
                </b-row>

                <b-collapse :id="'item-'+item._id+index" class="">
                    <b-form-textarea
                      id="textarea"
                      v-model="item.note"
                      placeholder="Hinweis für das Restaurant. z.B: Ohne Zwiebeln, mit Käse..."
                      rows="2"
                      max-rows="6"
                    ></b-form-textarea>
                    <div class="mt-3">
                       <b-form-checkbox
                       v-for="extra in item.extras" :key="extra.index"
                        v-model="extra.choosen"
                      >
                        <p class="m-0">{{ extra.title }} +{{ extra.price.toFixed(2) }}€</p>
                      </b-form-checkbox>
                    </div>
                </b-collapse>

              </div>
              
              <hr class="m-2">
              

              <b-row class="m-0 justify-content-between">
                <h3>Gesamtpreis:</h3>
                <h3>{{ totalPrice }}€</h3>
              </b-row>

              <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue ? 'text-success' : 'text-danger'">
                <small>Mindestbestellwert:</small>
                <small>{{ minDeliveryValue }}€</small>
              </b-row>
              <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue? 'text-success' : 'text-danger'">
                <small>Liefergebühr:</small>
                <small>{{ deliveryFee }}€</small>
              </b-row>
              <div v-if="!minDeliveryValue && delivery" class="text-danger justify-content-center">
                <p class="text-center">An diese Adresse ist keine Lieferung möglich!</p>
                <b-row class="m-0 justify-content-center">
                  <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse korrigieren</b-button>
                </b-row>
              </div>

              <div class="order-button shadow " :class="cart.length > 0 && (selectedTime || (delivery && parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue))  ? 'linear-warning hover' : 'bg-secondary forbidden' " @click="openOrderModal()">
                <b-row class="m-0 justify-content-center mt-2 ">
                  <h4 class="mt-2 pt-1">Bestellen</h4> 
                </b-row>
              </div>
              <div v-show="!restaurant.enable_online_order">
                <hr>
                <small> <strong>Hinweis:</strong> {{ restaurant.title }} bietet aktuell nur eine telefonische Bestellung an.</small>
              </div>
              
            </div>
       
      </div>
    </b-modal>

    <b-modal id="infoModal" size="md" v-model="ratingModal" hide-footer hide-header v-if="restaurant">
   
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;" v-if="restaurant.ratings">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >{{ restaurant.title }}</h4>
          <font-awesome-icon @click="ratingModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 justify-content-center" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
        <p class="m-0">Bewertungen ({{restaurant.ratings.length}}):</p>
        </b-row>
        <b-row class="m-0 pb-1 justify-content-center" style="border-top-left-radius: 10px; border-top-right-radius: 10px;" v-show="!restaurant.ratings">
        aktuell noch keine Bewertungen vorhanden
        </b-row>
        <div class="m-3" v-for="rating in restaurant.ratings" :key="rating.index">
          <b-row class="m-0 mx-4 justify-content-between">
            <small>{{ rating.sender }}</small>
            <small v-if="rating.date">{{ rating.date | moment('DD.MM.YY HH:mm')}}</small>
          </b-row>
          <p class="m-0 ml-4 mt-2">{{ rating.text }}</p>
          
          <b-form-rating readonly class="hover mb-3 p-0 text-center" size="md" :no-border="true" variant="warning" v-model="rating.rating"></b-form-rating>           
          <hr class="mx-3">
        </div>
            
      </div>
    </b-modal>


    <b-modal id="infoModal" size="md" v-model="deliveryModal" hide-footer hide-header v-if="restaurant">
   
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;" v-if="restaurant.ratings">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >Lieferadresse angeben</h4>
          <font-awesome-icon @click="deliveryModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <div class="pb-3">
          <p class="m-0 text-center">Wohin soll geliefert werden?</p>
          <google-places-autocomplete-adress @getAddressData="setAddressData" class="mx-3"></google-places-autocomplete-adress>
        </div>
        
      </div>
    </b-modal>

    <b-modal id="eventModal" class="event-modal" size="md" v-model="eventModal" hide-footer hide-header no-close-on-esc no-close-on-backdrop v-if="restaurant">
   
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;" v-if="restaurant">
       
        <h3 class="pt-3 text-center text-dark" >{{ restaurant.title}}</h3>
        <p class="text-center mx-3 mt-3">Normalerweise sollte zu Ostern auch der Osterhase bei vielen Familien vorbeikommen und die Ostertage im Kreise der Liebsten zum Familienfest werden. Da aber in diesem Jahr dies kaum möglich ist, haben sich die Sternquell Brauerei Plauen, das Team von eatDorado.de, die Oelsnitzer Kultur GmbH und die Stadtwerke Oelsnitz/Vogtl. zusammengetan und wollen allen über 16 jährigen Oelsnitzer Bürger*innen einen kleinen Ostergruß hinterlassen. So werden ab Karfreitag direkt zu allen, die es wollen, insgesamt 1.000 Sternquell-Vierer-Packs direkt nach hause geliefert. Und das auch noch völlig kostenfrei. Von daher heißt es: schnell sein und abstauben.
        Wie geht es? - Wähle direkt auf der folgenden Seite deinen 4er Pack aus, gib die Adresse und den Ortsteil an, schließe die Bestellung ab, bekomme eine Bestätigungs-SMS und dann: aufmachen und genießen. Aber am Besten erst Ostersamstag, nach der Fastenzeit :-)
        <br><br>
        Die Teilnahme ist natürlich nur für Nutzer über 16 Jahre gemäß JuSchG. Die Lieferung ab Karfreitag erfolgt nur im Stadtgebiet der Großen Kreisstadt Oelsnitz/Vogtl. und ihren Ortsteilen.</p> <br>
        <p class="text-center mx-3 mt-1"><small> Diese Aktion ist auf einen Sternquell-Viererpack pro Haushalt begrenzt.</small></p>
        <p class="text-center mx-3 mt-1"><small> Es besteht kein Rechtsanspruch auf Teilnahme, Lieferung und sonstige Leistungen im Rahmen dieser Aktion gegenüber den Veranstaltern.</small></p>
        
        <hr>
        <p class="text-center">Mit freundlicher Unterstützung von:</p>
        <b-row class="m-0 justify-content-center">
          <div class="text-center mx-2" style="width: 200px; height: auto" @click="linkOpen('https://www.sternquell.de/')">
            <b-img-lazy class="mt-3 hover" :src="require(`@/assets/logos/sternquell-logo.png`)"  style="width: 120px; height: auto" fluid alt="Sternquell Logo"></b-img-lazy>  
          </div>
          <div class="text-center mx-2" style="width: 200px; height: auto"  @click="linkOpen('https://www.oelsnitz.de/')">
            <b-img-lazy class="mt-3 hover" :src="require(`@/assets/logos/okg-logo.png`)" style="width: 100px height: auto" fluid alt="OKG Logo"></b-img-lazy>  
          </div>
          <div class="text-center mx-2" style="width: 200px; height: auto" @click="linkOpen('https://www.oelsnitz.media/')">
            <b-img-lazy class="mt-3 hover" :src="require(`@/assets/logos/oelsnitz-media.png`)"  style="width: 80px height: auto" fluid alt="Vogtland Energie Logo"></b-img-lazy>  
          </div>
          <div class="text-center mx-2" style="width: 200px; height: auto">
            <b-img-lazy class="mt-5 hover" :src="require(`@/assets/logos/eatDoradoText.png`)" style="width: 100px height: auto" fluid alt="eatDorado Logo"></b-img-lazy>  
          </div>
        </b-row>
        <hr>
        <div class="pb-3">
          <p class="text-center">Diese Aktion richtet sich ausschließlich an Personen über 16 Jahren.</p>
          <p class="text-center">Ich bestätige, dass ich mindestens 16 Jahre alt bin.</p>
            <b-row class="m-0 m-3 justify-content-around ">

              <div class="mt-3 order-button shadow linear-success hover" @click="eventModal = false">
                <b-row class="m-0 justify-content-center mt-1">
                  <h5 class="mt-2 text-center" >Ja, ich bin 16 Jahre oder älter</h5>
                </b-row>
              </div>

              <div class="mt-3 order-button shadow linear-danger hover" @click="$router.back()">
                <b-row class="m-0 justify-content-center mt-1">
                  <h5 class="mt-2 text-center">Nein, ich bin noch nicht 16 Jahre alt</h5>
                </b-row>
              </div>
            </b-row>
        </div>
        
      </div>
    </b-modal>

    <b-modal id="infoModal" size="md" v-model="timeModal" hide-footer hide-header v-if="restaurant">
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >Abholzeiten</h4>
          <font-awesome-icon  @click="timeModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        
          <b-calendar
            selected-variant="warning"
            today-variant="danger"
            nav-button-variant="warning"
            block
            class=""
            hide-header
            :min="new Date()"
            :max="new Date(Date.now() + 12096e5)"
            :locale="'de'"
            :start-weekday="1"
            v-model="selectedDate"
            :date-disabled-fn="dateDisabled"
          ></b-calendar>

          <b-row class="justify-content-around mx-3 mt-3 pb-3" v-if="slots">
            <div v-for="slot in slots" :key="slot.index">
              <b-button style="width: 90px" :disabled="slot.slots <= 0" class="m-2" :class="slot.slots <= 0 ? 'bg-danger' : ''" :variant="preTime.time == slot.time ? 'dark' : 'outline-dark'" @click="selectTime(slot, slot)">{{slot.time}}</b-button>
            </div>
            <div class="my-5 mx-2" v-show="slots.length == 0">
              <h3 class="text-center">An diesem Tag sind leider keine Abholzeiten verfügbar</h3>
            </div>
          </b-row>
      </div>
    </b-modal>

    <!-- mobile order -->

    <div v-if="restaurant && isMobile && !restaurant.event" class="d-block d-lg-none shadow bg-white" style="z-index: 3001; position: fixed; bottom: 0px; left: 0; right: 0; transition: all 0.3s ease-in-out; height: 100vh; overflow: auto" :style="expanded ? 'height: 100%' : restaurant.delivery ? 'height: 125px' : 'height: 85px'" >
      
      <b-row class="m-0 py-3 justify-content-between" style="transition: all .5s; " :style="restaurant.delivery ? 'height: 70px' : 'height: 85px'" :class="animateCart ? 'bg-success' : 'bg-warning'" @click="expanded = !expanded">
        <div style="position: relative">
          <font-awesome-icon class="ml-3 h1 hover text-dark" :icon="['fas', 'shopping-cart']"/>
          <h2 class="m-0 p-0" style="position: absolute; top: -15px; left: 40px"><b-badge pill variant="info">{{ getCartItems }}</b-badge></h2>
        </div>
        <font-awesome-icon v-show="expanded" class="ml-3 h3 mt-2 hover text-dark" :icon="['fas', 'chevron-down']"/>
        <h3 class="mr-3 mt-2 text-dark">Warenkorb {{ totalPrice }} €</h3>
      </b-row>
      <b-row v-if="restaurant.delivery" class="m-0 pb-3 justify-content-around" style="transition: all .5s; height: 55px" :class="animateCart ? 'bg-success' : 'bg-warning'">
        <b-button :disabled="!checkDeliveryTimes()" v-if="!orderModalMobile||delivery" :variant="delivery === true ? 'dark' : 'outline-dark'" @click="delivery = true">liefern</b-button>
        <b-button v-if="!orderModalMobile||!delivery" :variant="delivery === false ? 'dark' : 'outline-dark'" @click="delivery = false">abholen</b-button>
      </b-row>

      <!-- Before Order -->
      <div class="bg-white" style="transition: all .5s;" v-show="!orderModalMobile && expanded">
        <div class="ml-lg-5 p-3 ">
          <div class="m-0 mt-4 mb-4" v-if="delivery === true">
            <p class="text-center" v-if="adressData_delivery">{{ adressData_delivery.locality }}</p>
            <b-row class="m-0 justify-content-center">
              <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse ändern</b-button>
            </b-row>
          </div>
          <div v-if="restaurant.delivery && delivery === true">
            <b-row class="m-0 mb-2 justify-content-center" >
              <h5 class="m-0 text-center mb-2" >Durchschnittliche Lieferzeit: <br> ca. <span class="text-info"> {{ restaurant.actual_delivery_time }}</span> min ab Bestellbestätigung</h5>
            </b-row>
          </div>

          <div v-if="!restaurant.delivery || !checkDeliveryTimes()  || (restaurant.delivery && delivery === false)">
            <b-row class="m-0 justify-content-between">
              <p class="m-0 mb-3">Abholzeit wählen:</p>
            </b-row>
            <b-row class="justify-content-around" v-if="slots">
              <b-button v-if="slots[0] && !selectedDate" class="m-0" :class="slots[0].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[0].slots <= 0" :variant="preTime.time == slots[0].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[0], slots[0])">{{ slots[0].time }}</b-button>
              <b-button v-if="slots[1] && !selectedDate" class="m-0" :class="slots[1].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[1].slots <= 0" :variant="preTime.time == slots[1].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[1], slots[1])">{{ slots[1].time }}</b-button>
              <b-button v-if="slots[2] && !selectedDate" class="m-0" :class="slots[2].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[2].slots <= 0" :variant="preTime.time == slots[2].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[2], slots[2])">{{ slots[2].time }}</b-button>
              <b-button v-show="slots.length > 0" class="m-0" :key="slots.length" :variant="getMoreVariant()" @click="timeModal = true">später</b-button>
              <b-button v-show="slots.length == 0" class="m-0" disabled variant="dark">heute keine Abholung möglich</b-button>
              <b-button v-show="slots.length == 0" class="m-0" :variant="preTime.time ? 'dark' : 'outline-dark'" @click="timeModal = true">andere</b-button>
            </b-row>
            <b-row class="m-0 my-4 justify-content-between">
              <h5 class="m-0" v-if="selectedTime">{{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5>
              <h5 class="m-0 text-center text-danger" v-if="selectedTime == 'over' && warning">Die gewählte Zeit ist nicht mehr verfügbar</h5>
            </b-row>
          </div>
          
          <p class="text-center mt-4" v-show="cart.length == 0">Wähle leckere Gerichte aus der Karte und bestelle Dein Menü.</p>
          
          <div class="bg-light p-2 rounded" style="max-height: 40vh; overflow-y: auto">
            <div class="my-3" v-for="(item, index) in cart" :key="item.index">
              <cart-item :cartItem="item" :cart="cart" :index="index"></cart-item>
            </div>
          </div>
          <hr class="m-2">
          <b-row class="m-0 justify-content-between">
            <h3>Gesamtpreis:</h3>
            <h3>{{ totalPrice }}€</h3>
          </b-row>

          <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue ? 'text-success' : 'text-danger'">
            <p class="m-0">Mindestbestellwert:</p>
            <p class="m-0">{{ minDeliveryValue }}€</p>
          </b-row>
          <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue? 'text-success' : 'text-danger'">
            <p>Liefergebühr:</p>
            <p>{{ deliveryFee }}€</p>
          </b-row>

          <div v-if="!minDeliveryValue && delivery" class="text-danger justify-content-center">
            <p class="text-center">An diese Adresse ist keine Lieferung möglich!</p>
          </div>

          <div class="order-button shadow " :class="cart.length > 0 && (selectedTime || (delivery && parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue)) ? 'linear-warning hover' : 'bg-secondary forbidden' " @click="openOrderModalMobile()">
            <b-row class="m-0 justify-content-center mt-2 ">
              <h4 class="mt-2 pt-1">Bestellen</h4> 
            </b-row>
          </div>
          <div v-show="!restaurant.enable_online_order">
            <hr>
            <small> <strong>Hinweis:</strong> {{ restaurant.title }} bietet aktuell nur eine telefonische Bestellung an.</small>
          </div>
          <div class="mt-4">
            <hr>
            <p>Zahlungsmethoden {{ delivery ? 'an deiner Haustüre' : 'vor Ort' }}:</p>
            <div class="my-2 pt-0" v-show="restaurant.payment_methods.cash">
              <font-awesome-icon class="text-success" icon="money-bill-wave" /> Bar
            </div>
            <div class="my-2" v-show="restaurant.payment_methods.card">
              <font-awesome-icon class="text-dark" icon="credit-card" /> EC Karte
            </div>
            <div class="my-2" v-show="restaurant.payment_methods.paypal">
              <font-awesome-icon class="text-primary" :icon="['fab', 'cc-paypal']"/> PayPal
            </div>
            <div class="my-2" v-show="restaurant.payment_methods.credit_card">
              <font-awesome-icon class="text-dark" :icon="['fab', 'cc-visa']"/> Kreditkarte
            </div>
          </div>
        </div>
      </div>

      <!-- Order -->
      <div class="p-3 bg-white" v-show="!orderActive && orderModalMobile && expanded">
        <b-row class="m-0 my-4 justify-content-between" v-if="restaurant.delivery && delivery === false">
          <h5 class="m-0" v-if="selectedTime">{{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5>
          <h5 class="m-0 text-center text-danger" v-if="selectedTime == 'over' && warning">Die gewählte Zeit ist nicht mehr verfügbar</h5>
        </b-row>
        <div class="m-0 mt-4" v-if="delivery === true">
          <p class="text-center" v-if="adressData_delivery">{{ adressData_delivery.locality }}</p>
          <b-row class="m-0 justify-content-center">
            <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse ändern</b-button>
          </b-row>
        </div>
        <div v-if="restaurant.delivery && delivery === true">
          <b-row class="m-0 mb-2 justify-content-center" >
            <h5 class="m-0 text-center mb-2" >Durchschnittliche Lieferzeit: <br> ca. <span class="text-info"> {{ restaurant.actual_delivery_time }}</span> min ab Bestellbestätigung</h5>
          </b-row>
        </div>
        <div class="bg-light p-2 rounded" style="max-height: 40vh; overflow-y: auto">
          <div class="my-3" v-for="(item, index) in cart" :key="item.index">
            <cart-item :cartItem="item" :cart="cart" :index="index" :checkOrder="true"></cart-item>
          </div>
        </div>
        <hr class="m-2">

        
        <b-row class="m-0 justify-content-between w-100">
          <h3>Gesamtpreis:</h3>
          <h3>{{ totalPrice }}€</h3>
        </b-row>

        <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue ? 'text-success' : 'text-danger'">
          <p class="m-0">Mindestbestellwert:</p>
          <p class="m-0">{{ minDeliveryValue }}€</p>
        </b-row>

        <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue? 'text-success' : 'text-danger'">
          <p>Liefergebühr:</p>
          <p>{{ deliveryFee }}€</p>
        </b-row>

        <div v-if="!minDeliveryValue && delivery" class="text-danger justify-content-center">
          <p class="text-center">An diese Adresse ist keine Lieferung möglich!</p>
          <b-row class="m-0 justify-content-center">
            <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse korrigieren</b-button>
          </b-row>
        </div>


        <div v-show="restaurant.enable_online_order"> 

          <div class="order-button shadow linear-warning hover" @click="orderActive = true">
            <b-row class="m-0 justify-content-center mt-2 ">
              <h5 class="mt-2 pt-1 text-center">Bestellung online abschließen</h5> 
            </b-row>
          </div>
          
          <p class="text-center mt-3">Oder per Telefon bestellen:</p>
        </div>
        
        <div class="w-100 mt-3" >
          <hr>
          <div class="order-button shadow d-block d-md-none" :class="cart.length > 0 ? 'linear-warning hover' : 'bg-secondary forbidden' " @click="orderModalMobile = true">

            <b-row class="m-0 justify-content-center mt-2 hover">
              <a :href="'tel:'+restaurant.contact.phone"><h4 class="mt-2 pt-1">{{ restaurant.title }} jetzt anrufen</h4> </a> 
            </b-row>
          </div>
          <div class="d-none d-lg-block">
            <div>
              <p class="text-center">Telefonnummer:</p>
            </div>
            
            <div>
              <h1 class="text-center">{{ restaurant.contact.phone }}</h1>
            </div>
          </div>
          
          
          <div v-show="!restaurant.enable_online_order">
            <hr>
            <small> <strong>Hinweis:</strong> {{ restaurant.title }} bietet aktuell nur eine telefonische Bestellung an.</small>
          </div>
        </div>
        <div v-show="!restaurant.enable_online_order" class="d-block d-md-none">
          <hr>
          <small> <strong>Empfehlung:</strong> Stelle dein Telefon auf Lautsprecher, so kannst du die Bestellung ganz einfach hier ablesen.</small>
        </div>
      </div>

      <div class="p-3 bg-white" v-show="orderActive && restaurant.enable_online_order && expanded">
        <div v-show="!loggedIn && !orderState.sms_sent && !(orderState.verified === false)">
          <b-row class="m-0 mb-3 justify-content-between">
            <h5 class="m-0" v-if="selectedTime">Abholung: {{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5> 
          </b-row>
          <b-tabs content-class="mt-3" justified v-model="tabIndex">
            <b-tab title="Einloggen" disabled>
              
              <b-form-group
                label="E-Mail-Addresse:"
                >
                  <b-form-input
                    :state="form.email ? true : false"
                    v-model="form.email"
                    type="email"
                    placeholder="E-Mail eingeben..."
                    :required="tabIndex == 0"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                label="Passwort:"
                >
                  <b-form-input
                    :state="form.password ? true : false"
                    v-model="form.password"
                    type="password"
                    placeholder="Passwort eingeben..."
                    :required="tabIndex == 0"
                  ></b-form-input>
                </b-form-group>
                
            </b-tab>
            <b-tab title="Als Gast bestellen" active>
              <b-form></b-form>
                    <b-form-group
                    label="Vorname:"
                    >
                      <b-form-input
                        name="firstname"
                        :state="order.firstname ? true : false"
                        v-model="order.firstname"
                        type="text"
                        placeholder="Vorname eingeben..."
                        :required="tabIndex == 1"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                    label="Nachname:"
                    >
                      <b-form-input
                        name="lastname"
                        :state="order.lastname ? true : false"
                        v-model="order.lastname"
                        type="text"
                        placeholder="Nachname eingeben..."
                        :required="tabIndex == 1"
                      ></b-form-input>
                    </b-form-group>
                    <div v-if="delivery && adressData_delivery">
                      <p class="m-0 my-2">Lieferadresse:</p>
                      <p class="m-0 ">{{ adressData_delivery.locality }}</p>
                      <b-button class="my-2" size="sm" @click="deliveryModal = true">Lieferadresse korrigieren</b-button>
                    </div>
                    <b-form-group
                    label="Mobilnummer:"
                    description="Das Restaurant benötigt deine Mobilnummer für eventuelle Rückfragen und zur Bestätigung der Bestellung. An diese Nummer wird ein Code per SMS gesendet."
                    > 
                      <b-row>
                        <b-col cols="2" class="pr-0">
                          <b-form-input

                            v-model="preNumber"
                            type="text"
                            disabled
                            placeholder="+49"
                            :required="tabIndex == 1"
                          ></b-form-input>
                        </b-col>
                        <b-col cols="10" class="pl-1">
                          <b-form-input
                            name="phone"
                            :state="!order.phone || (orderState.order_sent && !orderState.sms_sent) || order.phone.length < 10 ? false : true"
                            v-model="order.phone"
                            type="text"
                            placeholder="Mobilnummer eingeben..."
                            :required="tabIndex == 1"
                          ></b-form-input>
                          
                        </b-col>
                      </b-row>
                      <b-form-invalid-feedback :state="orderState.order_sent && !orderState.sms_sent ? false : true">
                        An die Angegebene Mobilnummer konnte keine SMS gesendet werden, bitte überprüfe die Richtigkeit der Nummer.
                      </b-form-invalid-feedback>
                      
                    </b-form-group>

                    <div class="mt-3" v-show="!orderState.confirmation_required && !orderState.sms_sent && !(orderState.verified === false)"> 
                      <b-form-checkbox
                        class="mt-3"
                        v-model="order.dsgvo_accepted"
                        name="checkbox-dsvgo"
                        required
                      >
                        Ich habe die <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a> gelesen und Stimme zu. {{ delivery ? '' : 'Außerdem bestätige ich, die bestellte Ware abzuholen und im Restaurant zu bezahlen.'}}
                      </b-form-checkbox>
                      <div class="mt-3" v-if="delivery && parseFloat(totalPrice) < minDeliveryValue"> 
                        <p class="text-center text-danger">Mindestbestellwert nicht erreicht!</p>
                      </div>
                      <div class="mt-3" v-if="delivery && !minDeliveryValue">
                        <p class="text-center text-danger">An diese Adresse ist keine Lieferung möglich!</p>
                      </div>
                      <div class="mt-3 order-button shadow" :class="((delivery && parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue) || !delivery) && order.dsgvo_accepted && ((tabIndex == 0 && (order.email && order.password)) || (tabIndex == 1 && (order.firstname && order.lastname && order.phone)))? 'linear-warning hover' : 'bg-secondary forbidden' ">
                        <b-row class="m-0 justify-content-center mt-2 ">
                          <h5 v-show="!updating" class="mt-2 pt-1 text-center" @click="postOrder()">Zahlungspflichtig bestellen</h5>
                          <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
                        </b-row>
                      </div>
                    
                    </div>
            </b-tab>
          </b-tabs>
          
        </div>
        <!-- <div class="mt-3" v-show="!orderState.confirmation_required && !orderState.sms_sent && !(orderState.verified === false)"> 
          <b-form-checkbox
            class="mt-3"
            v-model="order.dsgvo_accepted"
            name="checkbox-dsvgo"
            required
          >
            Ich habe die <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a> gelesen und Stimme zu. Außerdem bestätige ich, die bestellte Ware abzuholen und im Restaurant zu bezahlen.
          </b-form-checkbox>
          <div class="mt-3 order-button shadow" :class="order.dsgvo_accepted && ((tabIndex == 0 && (order.email && order.password)) || (tabIndex == 1 && (order.firstname && order.lastname && order.phone)))? 'linear-warning hover' : 'bg-secondary forbidden' ">
            <b-row class="m-0 justify-content-center mt-2 ">
              <h5 v-show="!updating" class="mt-2 pt-1 text-center" @click="postOrder()">Zahlungspflichtig bestellen</h5>
              <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
            </b-row>
          </div>
        
        </div> -->

        <div v-show="orderState.confirmation_required || orderState.verified === false && !orderState.enable_refresh">
          <h3 class="text-center mb-5">Wir haben Dir einen Bestätigungscode per SMS gesendet.</h3>
          <p class="text-center">Dieser Code ist 5 Minuten lang gültig, danach wird deine Bestellung automatisch storniert.</p>
          <h4 class="text-center">Bitte gib den Code ein:</h4>
          <b-row class="m-0 my-5 justify-content-center">
            <p v-show="orderState.verified === false" class="text-center text-danger">{{ orderState.message }}</p>
            <Sms v-model="securityCode"></Sms>
          </b-row>
          <p class="text-center custom-nav" @click="resendCode">Code <span v-show="timer > 0">in {{timer}} Sekunden</span> erneut schicken</p>
          <p class="text-center">SMS kommt nicht an? <span class="custom-nav hover text-info" @click="resetOrder()">Bestellung {{ timer > 0 ? 'in '+timer+' Sekunden' : '' }} neu aufgeben.</span></p>
          <div class="order-button shadow" @click="confirmOrder()" :class="securityCode.length == 6 ? 'linear-warning hover' : 'bg-secondary forbidden'">
            <b-row class="m-0 justify-content-center mt-2 " >
              <h5 v-show="!updating" class="mt-2 pt-1 text-center" >Bestellung bestätigen</h5>
              <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
            </b-row>
          </div>
        </div>
        <div v-show="orderState.enable_refresh">
          <h3 class="text-center text-danger my-3"> 
            Die Bestellung wurde storniert und ist ungültig.
          </h3>
          <p class="text-center my-3">Der Code ist leider nicht mehr gültig, die Bestellung wurde storniert.</p>
          <div class="order-button shadow linear-warning hover" @click="resetOrder()">
            <b-row class="m-0 justify-content-center mt-2 " >
              <h5 v-show="!updating" class="mt-2 pt-1 text-center" >Erneut bestellen</h5>
              <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
            </b-row>
          </div>
        </div>
      </div>

    </div>

    <div v-if="restaurant && isMobile && restaurant.event" class="d-block d-lg-none shadow bg-white" style="z-index: 3001; position: fixed; bottom: 0px; left: 0; right: 0; transition: all 0.3s ease-in-out; height: 100vh; overflow: auto" :style="expanded ? 'height: 100%' : restaurant.delivery ? 'height: 85px' : 'height: 85px'" >
      
      <b-row class="m-0 py-3 justify-content-between" style="transition: all .5s; " :style="restaurant.delivery ? 'height: 85px' : 'height: 85px'" :class="animateCart ? 'bg-success' : 'bg-warning'" @click="expanded = !expanded">
        <div style="position: relative">
          <font-awesome-icon class="ml-3 h1 hover text-dark" :icon="['fas', 'shopping-cart']"/>
          <h2 class="m-0 p-0" style="position: absolute; top: -15px; left: 40px"><b-badge pill variant="info">{{ getCartItems }}</b-badge></h2>
        </div>
        <font-awesome-icon v-show="expanded" class="ml-3 h3 mt-2 hover text-dark" :icon="['fas', 'chevron-down']"/>
        <h3 class="mr-3 mt-2 text-dark">Warenkorb {{ totalPrice }} €</h3>
      </b-row>

      <!-- Before Order -->
      <div class="bg-white" style="transition: all .5s;" v-show="!orderModalMobile && expanded">
        <div class="ml-lg-5 p-3 ">
          <!-- <div class="m-0 mt-4 mb-4" v-if="delivery === true">
            <p class="text-center" v-if="adressData_delivery">{{ adressData_delivery.locality }}</p>
            <b-row class="m-0 justify-content-center">
              <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse ändern</b-button>
            </b-row>
          </div>
          <div v-if="restaurant.delivery && delivery === true">
            <b-row class="m-0 mb-2 justify-content-center" >
              <h5 class="m-0 text-center mb-2" >Durchschnittliche Lieferzeit: <br> ca. <span class="text-info"> {{ restaurant.actual_delivery_time }}</span> min ab Bestellbestätigung</h5>
            </b-row>
          </div> -->

          <!-- <div v-if="!restaurant.delivery || !checkDeliveryTimes()  || (restaurant.delivery && delivery === false)">
            <b-row class="m-0 justify-content-between">
              <p class="m-0 mb-3">Abholzeit wählen:</p>
            </b-row>
            <b-row class="justify-content-around" v-if="slots">
              <b-button v-if="slots[0] && !selectedDate" class="m-0" :class="slots[0].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[0].slots <= 0" :variant="preTime.time == slots[0].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[0], slots[0])">{{ slots[0].time }}</b-button>
              <b-button v-if="slots[1] && !selectedDate" class="m-0" :class="slots[1].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[1].slots <= 0" :variant="preTime.time == slots[1].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[1], slots[1])">{{ slots[1].time }}</b-button>
              <b-button v-if="slots[2] && !selectedDate" class="m-0" :class="slots[2].slots <= 0 ? 'bg-danger' : ''" :disabled="slots[2].slots <= 0" :variant="preTime.time == slots[2].time && selectedDate == null ? 'dark' : 'outline-dark'" @click="selectedDate = null, selectTime(slots[2], slots[2])">{{ slots[2].time }}</b-button>
              <b-button v-show="slots.length > 0" class="m-0" :key="slots.length" :variant="getMoreVariant()" @click="timeModal = true">später</b-button>
              <b-button v-show="slots.length == 0" class="m-0" disabled variant="dark">heute keine Abholung möglich</b-button>
              <b-button v-show="slots.length == 0" class="m-0" :variant="preTime.time ? 'dark' : 'outline-dark'" @click="timeModal = true">andere</b-button>
            </b-row>
            <b-row class="m-0 my-4 justify-content-between">
              <h5 class="m-0" v-if="selectedTime">{{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5>
              <h5 class="m-0 text-center text-danger" v-if="selectedTime == 'over' && warning">Die gewählte Zeit ist nicht mehr verfügbar</h5>
            </b-row>
          </div> -->
          
          <p class="text-center mt-4" v-show="cart.length == 0">Wähle ein Aktionsprodukt.</p>
          
          <div class="bg-light p-2 rounded" style="max-height: 40vh; overflow-y: auto">
            <div class="my-3" v-for="(item) in cart" :key="item.index">
              <p class="text-center">{{ item.title }}</p>
            </div>
          </div>
          <hr class="m-2">
          <b-row class="m-0 justify-content-between">
            <h3>Gesamtpreis:</h3>
            <h3>{{ totalPrice }}€</h3>
          </b-row>

          <div class="order-button shadow " :class="cart.length > 0 ? 'linear-warning hover' : 'bg-secondary forbidden' " @click="openOrderModalMobileEvent()">
            <b-row class="m-0 justify-content-center mt-2 ">
              <h4 class="mt-2 pt-1">Bestellen</h4> 
            </b-row>
          </div>
          <div v-show="!restaurant.enable_online_order">
            <hr>
            <small> <strong>Hinweis:</strong> {{ restaurant.title }} bietet aktuell nur eine telefonische Bestellung an.</small>
          </div>
        </div>
      </div>

      <!-- Order -->
      <!-- <div class="p-3 bg-white" v-show="!orderActive && orderModalMobile && expanded">
        <b-row class="m-0 my-4 justify-content-between" v-if="restaurant.delivery && delivery === false">
          <h5 class="m-0" v-if="selectedTime">{{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5>
          <h5 class="m-0 text-center text-danger" v-if="selectedTime == 'over' && warning">Die gewählte Zeit ist nicht mehr verfügbar</h5>
        </b-row>
        <div class="m-0 mt-4" v-if="delivery === true">
          <p class="text-center" v-if="adressData_delivery">{{ adressData_delivery.locality }}</p>
          <b-row class="m-0 justify-content-center">
            <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse ändern</b-button>
          </b-row>
        </div>
        <div v-if="restaurant.delivery && delivery === true">
          <b-row class="m-0 mb-2 justify-content-center" >
            <h5 class="m-0 text-center mb-2" >Durchschnittliche Lieferzeit: <br> ca. <span class="text-info"> {{ restaurant.actual_delivery_time }}</span> min ab Bestellbestätigung</h5>
          </b-row>
        </div>
        <div class="bg-light p-2 rounded" style="max-height: 40vh; overflow-y: auto">
          <div class="my-3" v-for="(item, index) in cart" :key="item.index">
            <cart-item :cartItem="item" :cart="cart" :index="index" :checkOrder="true"></cart-item>
          </div>
        </div>
        <hr class="m-2">

        
        <b-row class="m-0 justify-content-between w-100">
          <h3>Gesamtpreis:</h3>
          <h3>{{ totalPrice }}€</h3>
        </b-row>

        <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue ? 'text-success' : 'text-danger'">
          <p class="m-0">Mindestbestellwert:</p>
          <p class="m-0">{{ minDeliveryValue }}€</p>
        </b-row>

        <b-row v-if="delivery == true && minDeliveryValue" class="m-0 justify-content-between" :class="parseFloat(totalPrice) > minDeliveryValue && minDeliveryValue? 'text-success' : 'text-danger'">
          <p>Liefergebühr:</p>
          <p>{{ deliveryFee }}€</p>
        </b-row>

        <div v-if="!minDeliveryValue && delivery" class="text-danger justify-content-center">
          <p class="text-center">An diese Adresse ist keine Lieferung möglich!</p>
          <b-row class="m-0 justify-content-center">
            <b-button class="mb-2" size="sm" @click="deliveryModal = true">Lieferadresse korrigieren</b-button>
          </b-row>
        </div>


        <div v-show="restaurant.enable_online_order"> 

          <div class="order-button shadow linear-warning hover" @click="orderActive = true">
            <b-row class="m-0 justify-content-center mt-2 ">
              <h5 class="mt-2 pt-1 text-center">Bestellung online abschließen</h5> 
            </b-row>
          </div>
          
          <p class="text-center mt-3">Oder per Telefon bestellen:</p>
        </div>
        
        <div class="w-100 mt-3" >
          <hr>
          <div class="order-button shadow d-block d-md-none" :class="cart.length > 0 ? 'linear-warning hover' : 'bg-secondary forbidden' " @click="orderModalMobile = true">

            <b-row class="m-0 justify-content-center mt-2 hover">
              <a :href="'tel:'+restaurant.contact.phone"><h4 class="mt-2 pt-1">{{ restaurant.title }} jetzt anrufen</h4> </a> 
            </b-row>
          </div>
          <div class="d-none d-lg-block">
            <div>
              <p class="text-center">Telefonnummer:</p>
            </div>
            
            <div>
              <h1 class="text-center">{{ restaurant.contact.phone }}</h1>
            </div>
          </div>
          
          
          <div v-show="!restaurant.enable_online_order">
            <hr>
            <small> <strong>Hinweis:</strong> {{ restaurant.title }} bietet aktuell nur eine telefonische Bestellung an.</small>
          </div>
        </div>
        <div v-show="!restaurant.enable_online_order" class="d-block d-md-none">
          <hr>
          <small> <strong>Empfehlung:</strong> Stelle dein Telefon auf Lautsprecher, so kannst du die Bestellung ganz einfach hier ablesen.</small>
        </div>
      </div> -->

      <div class="p-3 bg-white" v-show="orderActive && restaurant.enable_online_order && expanded">
        <div v-show="!loggedIn && !orderState.sms_sent && !(orderState.verified === false)">
          <b-row class="m-0 mb-3 justify-content-between">
            <h5 class="m-0" v-if="selectedTime">Abholung: {{ selectedTime | moment('dddd, DD.MM.YYYY HH:mm')}} </h5> 
          </b-row>
         

  <b-form-group
                    label="Vorname:"
                    >
                      <b-form-input
                        name="firstname"
                        :state="order.firstname && !orderState.double_order ? true : false"
                        v-model="order.firstname"
                        type="text"
                        placeholder="Vorname eingeben..."
                        required
                      ></b-form-input>
                      <b-form-invalid-feedback :state="orderState.double_order == false ? true : false">
                        <div v-if="orderState.double_order == true">
                          Für den angegebenen Haushalt wurde bereits eine Bestellung getätigt!
                        </div>                        
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                    label="Nachname:"
                    >
                      <b-form-input
                        name="lastname"
                        :state="order.lastname && !orderState.double_order ? true : false"
                        v-model="order.lastname"
                        type="text"
                        placeholder="Nachname eingeben..."
                        required
                      ></b-form-input>
                      <b-form-invalid-feedback :state="orderState.double_order == false ? true : false">
                        <div v-if="orderState.double_order == true">
                          Für den angegebenen Haushalt wurde bereits eine Bestellung getätigt!
                        </div>                        
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                    label="Straße und Hausnummer:"
                    >
                      <b-form-input
                        name="street"
                        :state="eventOrder.street && !orderState.double_order ? true : false"
                        v-model="eventOrder.street"
                        type="text"
                        placeholder="Straße und Hausnummer eingeben..."
                        required
                      ></b-form-input>
                      <b-form-invalid-feedback :state="orderState.double_order == false ? true : false">
                        <div v-if="orderState.double_order == true">
                          Für den angegebenen Haushalt wurde bereits eine Bestellung getätigt!
                        </div>                        
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                    label="Postleitzahl:"
                    >
                      <b-form-input
                        name="zipcode"
                        :state="eventOrder.zipcode ? true : false"
                        v-model="eventOrder.zipcode"
                        type="text"
                        disabled
                        placeholder="Postleitzahl eingeben..."
                        required
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                    label="Stadt / Ort:"
                    >
                      <b-form-select :state="eventOrder.city ? true : false" v-model="eventOrder.city" :options="cityOptions"></b-form-select>
                    </b-form-group>
                    <b-form-group
                    label="Mobilnummer:"
                    description="Wir benötigen deine Mobilnummer für eventuelle Rückfragen und zur Bestätigung der Bestellung. An diese Nummer wird ein Code per SMS gesendet."
                    > 
                      <b-row>
                        <b-col cols="2" class="pr-0">
                          <b-form-input
                            v-model="preNumber"
                            type="text"
                            disabled
                            placeholder="+49"
                            required
                          ></b-form-input>
                        </b-col>
                        <b-col cols="10" class="pl-1">
                          <b-form-input
                            name="phone"
                            :state="!order.phone || (orderState.order_sent && !orderState.sms_sent) || order.phone.length < 10 ? false : true"
                            v-model="order.phone"
                            type="text"
                            placeholder="Mobilnummer eingeben..."
                            required
                          ></b-form-input>
                          
                        </b-col>
                      </b-row>
                      <b-form-invalid-feedback :state="orderState.order_sent && !orderState.sms_sent  ? false : true">
                        <div>
                          An die angegebene Mobilnummer konnte keine SMS gesendet werden, bitte überprüfe die Richtigkeit der Nummer.
                        </div>
                        
                      </b-form-invalid-feedback>
                      
                    </b-form-group>

                    <div class="mt-3" v-show="!orderState.confirmation_required && !orderState.sms_sent && !(orderState.verified === false)"> 
                      <b-form-checkbox
                        class="mt-3"
                        v-model="order.dsgvo_accepted"
                        name="checkbox-dsvgo"
                        required
                      >
                        Ich habe die <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a> gelesen und Stimme zu.
                      </b-form-checkbox>
                      <b-form-checkbox
                        class="mt-3"
                        v-model="order.over_sixteen"
                        name="checkbox-dsvgo"
                        required
                      >
                        Ich bin mindestens 16 Jahre alt.
                      </b-form-checkbox>
                    
                      <div class="mt-3 order-button shadow" :class="order.dsgvo_accepted && order.over_sixteen && order.firstname && order.lastname && order.phone && eventOrder.zipcode && eventOrder.city && eventOrder.street ? 'linear-warning hover' : 'bg-secondary forbidden' ">
                        <b-row class="m-0 justify-content-center mt-2 ">
                          <h5 v-show="!updating" class="mt-2 pt-1 text-center" @click="postOrderEvent()">Gratis bestellen</h5>
                          <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
                        </b-row>
                      </div>
                    
                    </div>

          
        </div>

        <div v-show="orderState.confirmation_required || orderState.verified === false && !orderState.enable_refresh">
          <h3 class="text-center mb-5">Wir haben Dir einen Bestätigungscode per SMS gesendet.</h3>
          <p class="text-center">Dieser Code ist 5 Minuten lang gültig, danach wird deine Bestellung automatisch storniert.</p>
          <h4 class="text-center">Bitte gib den Code ein:</h4>
          <b-row class="m-0 my-5 justify-content-center">
            <p v-show="orderState.verified === false" class="text-center text-danger">{{ orderState.message }}</p>
            <Sms v-model="securityCode"></Sms>
          </b-row>
          <p class="text-center custom-nav" @click="resendCode">Code <span v-show="timer > 0">in {{timer}} Sekunden</span> erneut schicken</p>
          <p class="text-center">SMS kommt nicht an? <span class="custom-nav hover text-info" @click="resetOrder()">Bestellung {{ timer > 0 ? 'in '+timer+' Sekunden' : '' }} neu aufgeben.</span></p>
          <div class="order-button shadow" @click="confirmOrder()" :class="securityCode.length == 6 ? 'linear-warning hover' : 'bg-secondary forbidden'">
            <b-row class="m-0 justify-content-center mt-2 " >
              <h5 v-show="!updating" class="mt-2 pt-1 text-center" >Bestellung bestätigen</h5>
              <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
            </b-row>
          </div>
        </div>
        <div v-show="orderState.enable_refresh">
          <h3 class="text-center text-danger my-3"> 
            Die Bestellung wurde storniert und ist ungültig.
          </h3>
          <p class="text-center my-3">Der Code ist leider nicht mehr gültig, die Bestellung wurde storniert.</p>
          <div class="order-button shadow linear-warning hover" @click="resetOrder()">
            <b-row class="m-0 justify-content-center mt-2 " >
              <h5 v-show="!updating" class="mt-2 pt-1 text-center" >Erneut bestellen</h5>
              <h5 v-show="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
            </b-row>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import Footer from '@/components/Footer'
import LoadingOverlay from '@/shared/animations/loadingOverlay.vue'
import Sms from '@/shared/plugins/security/src/security';
import MenuItem from '@/components/MenuItem'
import CartItem from '@/components/CartItem'
import GooglePlacesAutocompleteAdress from '@/components/GooglePlacesAutocompleteAdress'
export default {
  name: 'RestaurantView',
  components: {
    LoadingOverlay,
    Footer,
    MenuItem,
    Sms,
    CartItem,
    GooglePlacesAutocompleteAdress
  },
  beforeUpdate(){
   
  },
  data: () => {
    return {
      eventOrder: {
        street: '',
        zipcode: '08606',
        city: ''
      },
      choosenCity: null,
      cityOptions:[
          { value: 'Görnitz mit Tanzermühle', text: 'Görnitz mit Tanzermühle'},
          { value: 'Hartmannsgrün', text: 'Hartmannsgrün'},
          { value: 'Oberhermsgrün', text: 'Oberhermsgrün'},
          { value: 'Unterhermsgrün', text: 'Unterhermsgrün'},
          { value: 'Lauterbach', text: 'Lauterbach'},
          { value: 'Triebel', text: 'Triebel'},
          { value: 'Magwitz mit Göswein', text: 'Magwitz mit Göswein'},
          { value: 'Stadt Oelsnitz', text: 'Stadt Oelsnitz'},
          { value: 'Siedlung', text: 'Siedlung'},
          { value: 'Planschwitz', text: 'Planschwitz'},
          { value: 'Raasdorf', text: 'Raasdorf'},
          { value: 'Raschau', text: 'Raschau'},
          { value: 'Untermarxgrün', text: 'Untermarxgrün'},
          { value: 'Voigtsberg', text: 'Voigtsberg'},
          { value: 'Taltitz mit Dobeneck und Neue Welt', text: 'Taltitz mit Dobeneck und Neue Welt'},
        ],
      delivery: null,
      animateCart: false,
      isMobile: null,
      orderModalMobile: false,
      expanded: false,
      form: {
        email: '',
        password: ''
      },
      nextTimes: {
        time1: {
          date: null,
          time: null
        },
        time2: {
          date: null,
          time: null
        },
        time3: {
          date: null,
          time: null
        },
      },
      eventModal: false,
      orderModalEvent: false,
      now: null,
      deliveryModal: false,
      extrasItem: null,
      extrasModal: false,
      timeString: null,
      customDate: null,
      preNumber: '+49',
      days: [],
      timeModal: false,
      selectedTime: null,
      selectedDate: null,
      interval: null,
      timestamp: "",
      preTime: 0,
      dummy: null,
      timer: 60,
      securityCode: '',
      tabIndex: 0,
      orderActive: false,
      order: {dsgvo_accepted: false, phone:''},
      ratingModal: false,
      cartModal: false,
      orderModal: false,
      activeMenu: {},
      infoModal: false,
      cart: [],
      showDetail: false,
      // form: {},
      loginModal: false,
      registerActive: false,
      distance: 13,
      rating: 0,
      resendTimer: null,
      labels: {
          de: {
            labelPrevDecade: 'Vorheriges Jahrzehnt',
            labelPrevYear: 'Vorheriges Jahr',
            labelPrevMonth: 'Vorheriger Monat',
            labelCurrentMonth: 'Aktueller Monat',
            labelNextMonth: 'Nächster Monat',
            labelNextYear: 'Nächstes Jahr',
            labelNextDecade: 'Nächstes Jahrzehnt',
            labelToday: 'Heute',
            labelSelected: 'Ausgewähltes Datum',
            labelNoDateSelected: 'Kein Datum gewählt',
            labelCalendar: 'Kalender',
            labelNav: 'Kalendernavigation',
            labelHelp: 'Mit den Pfeiltasten durch den Kalender navigieren'
          },}
    }
  },
  computed: {
    minDeliveryValue(){
      var value = null
      if(!this.adressData_delivery) return value
      if(!this.adressData_delivery.latitude || !this.adressData_delivery.longitude) return value
      
      var distance = this.distanceInKmBetweenEarthCoordinates(this.adressData_delivery.latitude, this.adressData_delivery.longitude, this.restaurant.adress.lat, this.restaurant.adress.lon)
      
      this.restaurant.minimum_order_value.forEach(distances => {
        if(distance < distances.range){
          if(!value){
            value = distances.value.toFixed(2)
          }
        }
      })
      if(this.restaurant.maximum_delivery_radius < distance){
        value = null
      }
      return value
    },
    deliveryFee(){
      var value = null
      if(!this.adressData_delivery) return value
      if(!this.adressData_delivery.latitude || !this.adressData_delivery.longitude) return value
      
      var distance = this.distanceInKmBetweenEarthCoordinates(this.adressData_delivery.latitude, this.adressData_delivery.longitude, this.restaurant.adress.lat, this.restaurant.adress.lon)
      
      this.restaurant.minimum_order_value.forEach(distances => {
        if(distance < distances.range){
          if(!value){
            value = distances.delivery_fee.toFixed(2)
          }
        }
      })
      if(this.restaurant.maximum_delivery_radius < distance){
        value = null
      }
      if(this.delivery){
        return value
      }else{
        return 0.00
      }
      
    },
    distanceBetween(){
      var value = null
      if(!this.adressData_delivery) return value
      if(!this.adressData_delivery.latitude || !this.adressData_delivery.longitude) return value
      
      return this.distanceInKmBetweenEarthCoordinates(this.adressData_delivery.latitude, this.adressData_delivery.longitude, this.restaurant.adress.lat, this.restaurant.adress.lon)
      // return value
  },
    adressData_delivery(){
      return this.$store.getters.adressData_delivery
    },
    appversion(){
      return this.$store.getters.appversion
    },
    storedOrder(){
      return this.$store.getters.storedOrder
    },
    getCartItems(){
      var amount = 0
      if(this.cart){
        this.cart.forEach(element => {
          amount += element.amount
        })
      }
      return amount
    },
    warning(){
      if(this.slots && this.selectedTime){
        if(this.selectedTime < this.slots[0].date) {
          return true
        }
      }
      if(this.selectedTime == 'over') return true
      return false
    },
    slots(){
      return this.$store.getters.slots
    },
    updating(){
      return this.$store.getters.updating
    },
    orderState(){
      return this.$store.getters.orderState
    },
    loggedIn(){
      return this.$store.getters.loggedIn
    },
    getRating(){
      if(!this.restaurant.ratings) return 0.0
      var rating = 0.0
      this.restaurant.ratings.forEach(el => {
        rating += el.rating
      })

      return rating / this.restaurant.ratings.length
    },
    globalCart(){
      return this.$store.getters.globalCart
    },
    darkMode(){
      return this.$store.getters.darkMode
    },
    restaurant(){
      var restaurant = this.$store.getters.restaurant
      if(restaurant){
        restaurant.menus.sort( this.compareCatecories );
      }
      return restaurant
    },
    loadingRestaurant(){
      return this.$store.getters.loadingRestaurant
    },
    totalPrice(){
      var total = 0.00
      if(this.deliveryFee){
        total += parseInt(this.deliveryFee)
      }
      if(this.cart.length == 0) return total.toFixed(2)

      this.cart.forEach(item => {
        total += item.price * item.amount
        if(item.extras){
          item.extras.forEach(extra => {
            if(extra.choosen){
              total += extra.price * item.amount
              if(item.variants.length > 0){
                item.variants.forEach(variant => {
                  if(variant.choosen){
                    total += variant.choosen.extra_price * item.amount
                  }
                })
              }
            }
          })
          if(item.variants){
            if(item.variants.find(variant => variant.choosen)){
              item.variants.filter(variant => variant.choosen).forEach(element => {
                total += element.choosen.price * item.amount
              })
            }
          }
          
        }
      })
      
      return total.toFixed(2)
    }
  },
  watch: {
    loadingRestaurant(){
      // console.log(this.loadingRestaurant)
    },
    delivery(){
        this.selectedTime = null
        this.selectedDate = null
        if(!localStorage.getItem('adressData_delivery') && this.delivery  && !this.restaurant.event){
          this.deliveryModal = true
        }
    },
    deliveryModal(){
      if(!localStorage.getItem('adressData_delivery') && this.delivery && !this.deliveryModal){
        this.delivery = false
      }
    },
    expanded(){
      if(!this.expanded){
        this.resetOrder()
        this.orderModalMobile = false
        this.orderActive = false
      }
    },
    warning(){
      if(this.warning){
        this.selectedTime = 'over'
        this.ratingModal = false
        this.orderModal = false
      }
    },
    restaurant(){
      if(!this.restaurant) return
      const descEl = document.querySelector('head meta[name="description"]');
      const titleEl = document.querySelector('head title');

      descEl.setAttribute('content', this.restaurant.description);
      titleEl.textContent = 'ᐅ eatDorado | ' + this.restaurant.title + ' - ' + this.restaurant.adress.city;

      try {
        var date = JSON.parse(localStorage.getItem('valid_till'))
        if(new Date(date) > new Date()){
          this.dummy = JSON.parse(localStorage.getItem('cart'))
        }else{
          localStorage.setItem('cart', null)
        }
      } catch (error) {
        console.log(error)
      }

      if(this.globalCart.length == 0 && this.dummy){
        this.$store.commit('globalCart', this.dummy)
        if(this.dummy.find(el => el._id == this.restaurant._id)){

            this.cart = this.dummy.find(el => el._id == this.restaurant._id).cart
            this.cart.forEach((item, index) => {
              if(!this.restaurant.menus.find(el => el._id == item._id)){
                this.cart.splice(index, 1)
              }
            })
        }
      }else{
        if(this.globalCart.find(el => el._id == this.restaurant._id)){
            this.cart = this.globalCart.find(el => el._id == this.restaurant._id).cart
            this.cart.forEach((item, index) => {
              if(!this.restaurant.menus.find(el => el._id == item._id)){
                this.cart.splice(index, 1)
              }
            })
        }
      }
      this.$store.dispatch('checkSlots', {company: this.restaurant._id, date: this.timeString})
      if(this.restaurant.event){
        this.eventModal = true
        this.delivery = true
      }
    },
    selectedDate(){
      if(this.selectedDate){
        this.$store.dispatch('checkSlots', {company: this.restaurant._id, date: this.selectedDate})
        this.preTime = 0
        this.selectedTime = null
        this.timeString = this.selectedDate
      }
    },
    orderModal(){
      if(!this.orderModal){
        this.orderActive = false
        this.resetOrder()
        
      } 
    },
    orderModalEvent(){
      if(!this.orderModalEvent){
        this.orderActive = false
        this.resetOrder()
        
      } 
    },
    order: {
      handler: function () {
        this.$store.commit('orderState', {})
      },
      deep: true
    },
    cart: {
      handler: function () {
        var index = 0
        var payload = {
          _id: this.restaurant._id,
          cart: this.cart
        }
        var now = new Date();
        now.setHours(now.getHours() + 12)
        if(this.globalCart && this.cart ){
          if(this.globalCart.find(el => el._id == this.restaurant._id)){
            index = this.globalCart.findIndex(el => el._id == this.restaurant._id)
            this.globalCart.splice(index, 1)
            this.globalCart.push(payload)
            localStorage.setItem('cart', JSON.stringify(this.globalCart))
            localStorage.setItem('valid_till', JSON.stringify(now))
          }else{
            this.globalCart.push(payload)
            localStorage.setItem('cart', JSON.stringify(this.globalCart))
            localStorage.setItem('valid_till', JSON.stringify(now))
          }
        }
        
      },
      deep: true
    }
  },
  mounted(){
    if(localStorage.getItem('adressData_delivery')){
      this.$store.commit('adressData_delivery', JSON.parse(localStorage.getItem('adressData_delivery')))
    }
    this.checkVersions();
    // localStorage.setItem('cart', null)
    this.$nextTick(function() {
      
      window.addEventListener('resize', this.getWindowWidth);
      // document.getElementById('scroll-container').addEventListener('scroll', this.getScrollHeight)
      this.getWindowWidth()
    })

    this.getWindowWidth()
    var today = new Date()
    this.timeString =  today.getFullYear()+ '-' + ("0" + (today.getMonth()+1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2)
    
    if(this.restaurant){
      const descEl = document.querySelector('head meta[name="description"]');
      const titleEl = document.querySelector('head title');

      descEl.setAttribute('content', this.restaurant.description);
      titleEl.textContent = this.restaurant.title + ' ' + this.restaurant.adress.city;
      
      this.$store.dispatch('checkSlots', {company: this.restaurant._id, date: this.timeString})

    }
    
    this.getNow()
    this.interval = setInterval(this.getNow, 30000);
    this.$store.commit('orderState', {})
    this.$store.commit('restaurant', null)
    this.$store.dispatch('getRestaurant', {_id: this.$route.params.id})
    
    if(this.restaurant){
      this.dummy = JSON.parse(localStorage.getItem('cart'))
      var date = JSON.parse(localStorage.getItem('valid_till'))
      if((new Date(date) > new Date())){
        if(this.globalCart.length == 0 && this.dummy){
          this.$store.commit('globalCart', this.dummy)
        }
      }else{
        localStorage.setItem('cart', null)
        this.$store.commit('globalCart', [])
      }
      
      if(this.globalCart.find(el => el._id == this.restaurant._id)){
          this.cart = this.globalCart.find(el => el._id == this.restaurant._id).cart
      }
    }
    
  },
  beforeDestroy(){
    clearInterval(this.interval)
    clearInterval(this.resendTimer)
    window.removeEventListener('resize', this.getWindowWidth);
  },
  methods: {
    degreesToRadians(degrees) {
      return degrees * Math.PI / 180;
    },
    distanceInKmBetweenEarthCoordinates(lat1, lon1, lat2, lon2) {
      var earthRadiusKm = 6371;
    
      var dLat = this.degreesToRadians(lat2-lat1);
      var dLon = this.degreesToRadians(lon2-lon1);
    
      lat1 = this.degreesToRadians(lat1);
      lat2 = this.degreesToRadians(lat2);
    
      var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

      if(lat1 && lon1 && lat2 && lon2){
        return (earthRadiusKm * c).toFixed(2) ;
      }else{
        return null
      }
      
    },
    checkDeliveryTimes(){
      var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      var d = new Date();
      var dayName = days[d.getDay()];
      const openingTimes = this.restaurant.delivery_times[dayName]
      const today = new Date().getFullYear()+'-'+('0'+(new Date().getMonth()+1)).slice(-2)+'-'+('0'+new Date().getDate()).slice(-2)
      const dateStart_1 = new Date(today+'T'+openingTimes.start_1)
      const dateStart_2 = new Date(today+'T'+openingTimes.start_2)
      const dateEnd_1 = new Date(today+'T'+openingTimes.end_1)
      const dateEnd_2 = new Date(today+'T'+openingTimes.end_2)

      if(dateStart_1 < new Date() && dateEnd_1 > new Date()){
        return true
      }

      if(dateStart_2 < new Date() && dateEnd_2 > new Date()){
        return true
      }

      return false
    },
    setAddressData(value){
      this.$store.commit('adressData_delivery', value)
      var vm = this;
      setTimeout(function(){ vm.deliveryModal = false; }, 300);
    },
    checkVersions() {
      this.$store.dispatch('getAppversion')
      if(this.appversion){
        if(this.appversion.web_version != process.env.VUE_APP_VERSION){
          window.location.reload()
        }
      }
    },
    getOpeningTimes(){
      var timeString = {}
      var date = new Date()
      var day = date.getDay()
      switch (day) {
        case 0:
          if(this.restaurant.opening_times.sunday.start_1 && this.restaurant.opening_times.sunday.end_1){
            timeString.first = this.restaurant.opening_times.sunday.start_1 + ' - ' + this.restaurant.opening_times.sunday.end_1
          }
          if(this.restaurant.opening_times.sunday.start_2 && this.restaurant.opening_times.sunday.end_2){
            timeString.second = this.restaurant.opening_times.sunday.start_2 + ' - ' + this.restaurant.opening_times.sunday.end_2
          }
          return timeString
        case 1:
          if(this.restaurant.opening_times.monday.start_1 && this.restaurant.opening_times.monday.end_1){
            timeString.first = this.restaurant.opening_times.monday.start_1 + ' - ' + this.restaurant.opening_times.monday.end_1
          }
          if(this.restaurant.opening_times.monday.start_2 && this.restaurant.opening_times.monday.end_2){
            timeString.second = this.restaurant.opening_times.monday.start_2 + ' - ' + this.restaurant.opening_times.monday.end_2
          }
          return timeString
        case 2:
          if(this.restaurant.opening_times.tuesday.start_1 && this.restaurant.opening_times.tuesday.end_1){
            timeString.first = this.restaurant.opening_times.tuesday.start_1 + ' - ' + this.restaurant.opening_times.tuesday.end_1
          }
          if(this.restaurant.opening_times.tuesday.start_2 && this.restaurant.opening_times.tuesday.end_2){
            timeString.second = this.restaurant.opening_times.tuesday.start_2 + ' - ' + this.restaurant.opening_times.tuesday.end_2
          }
          return timeString
        case 3:
          if(this.restaurant.opening_times.wednesday.start_1 && this.restaurant.opening_times.wednesday.end_1){
            timeString.first = this.restaurant.opening_times.wednesday.start_1 + ' - ' + this.restaurant.opening_times.wednesday.end_1
          }
          if(this.restaurant.opening_times.wednesday.start_2 && this.restaurant.opening_times.wednesday.end_2){
            timeString.second = this.restaurant.opening_times.wednesday.start_2 + ' - ' + this.restaurant.opening_times.wednesday.end_2
          }
          return timeString
        case 4:
          if(this.restaurant.opening_times.thursday.start_1 && this.restaurant.opening_times.thursday.end_1){
            timeString.first = this.restaurant.opening_times.thursday.start_1 + ' - ' + this.restaurant.opening_times.thursday.end_1
          }
          if(this.restaurant.opening_times.thursday.start_2 && this.restaurant.opening_times.thursday.end_2){
            timeString.second = this.restaurant.opening_times.thursday.start_2 + ' - ' + this.restaurant.opening_times.thursday.end_2
          }
          return timeString
        case 5:
          if(this.restaurant.opening_times.friday.start_1 && this.restaurant.opening_times.friday.end_1){
            timeString.first = this.restaurant.opening_times.friday.start_1 + ' - ' + this.restaurant.opening_times.friday.end_1
          }
          if(this.restaurant.opening_times.friday.start_2 && this.restaurant.opening_times.friday.end_2){
            timeString.second = this.restaurant.opening_times.friday.start_2 + ' - ' + this.restaurant.opening_times.friday.end_2
          }
          return timeString
        case 6:
          if(this.restaurant.opening_times.saturday.start_1 && this.restaurant.opening_times.saturday.end_1){
            timeString.first = this.restaurant.opening_times.saturday.start_1 + ' - ' + this.restaurant.opening_times.saturday.end_1
          }
          if(this.restaurant.opening_times.saturday.start_2 && this.restaurant.opening_times.saturday.end_2){
            timeString.second = this.restaurant.opening_times.saturday.start_2 + ' - ' + this.restaurant.opening_times.saturday.end_2
          }
          return timeString
        default:
          break;
      }
    },

    scrollToCategory(id){
      var categoryPos = document.getElementById(id).offsetTop;
      var itemPos = document.getElementById('item-'+id).offsetLeft;

      var myDiv = document.getElementById('scroll-container');
      var scrollContainerCategories = document.getElementById('scroll-container-categories');

      myDiv.scrollTo({top: categoryPos -100, behavior: 'smooth'});
      scrollContainerCategories.scrollTo({left: itemPos - 10 , behavior: 'smooth'});
    },

    submitLogin(){
      var payload = {
        email: this.form.email,
        password: this.form.password,
        noredirect: true
      }
      this.$store.dispatch('login', payload)
    },
    // getScrollHeight() {

    //   var scrollContainerCategories = document.getElementById('scroll-container-categories');

    //   var vm = this
    //   var actualPos = document.getElementById('scroll-container').scrollTop
      
    //     vm.restaurant.categories.forEach( (element, index) => {
    //       var itemPos = document.getElementById('item-'+element._id).offsetLeft;
    //       if(actualPos - 100 < itemPos && actualPos - 100){
    //          scrollContainerCategories.scrollTo({left: itemPos - 10 , behavior: 'smooth'});
    //       }
    //       console.log(itemPos)
    //     }
    //   )

    // },
    getWindowWidth() {
      this.isMobile = document.documentElement.clientWidth < 992 ? true : false
    },
    resetOrder(){
      if(this.timer > 0 && !this.orderState.enable_refresh) return
      this.$store.commit('orderState', {})
      this.orderActive = false
      this.securityCode = ''
    },
    getMoreVariant(){

      if(this.slots){
        if(this.slots.length == 1){
          if(this.preTime.time != this.slots[0].time || this.selectedDate) return 'dark'
        }
        if(this.slots.length == 2){
          if(this.preTime.time != this.slots[0].time && this.preTime.time != this.slots[1].time || this.selectedDate) return 'dark'
        }
        if(this.slots.length >= 3){
          if(this.preTime.time != this.slots[0].time && this.preTime.time != this.slots[1].time && this.preTime.time != this.slots[2].time || this.selectedDate) return 'dark'
        }
       
      }
      return 'outline-dark'
    },
    getExtrasPrice(menu){
      var price = menu.price
      menu.extras.forEach(element => {
        if(element.choosen){
          price += element.price
          if(menu.variants.length > 0){
            menu.variants.forEach(variant => {
              if(variant.choosen){
                price += variant.choosen.extra_price
              }
            })
          }
        }
      });
      if(menu.variants){
        if(menu.variants.find(variant => variant.choosen)){
          menu.variants.filter(variant => variant.choosen).forEach(element => {
            price += element.choosen.price
          })
        }
      }
      
       return price.toFixed(2)
    },
    getCategory(menu, index){
      if(!menu.category) return
      if(!this.restaurant.menus[index - 1])return this.restaurant.menus[index].category
      if(this.restaurant.menus[index].category.title != this.restaurant.menus[index - 1].category.title) return this.restaurant.menus[index].category
    },
    compareCatecories( a, b ) {
      if(a.category && b.category){
        var A = a.category.title
        var B = b.category.title
        if ( A < B ){
          return -1;
        }
        if ( A > B ){
          return 1;
        }
        return 0;
      }
    },
    openOrderModal(){
      if(!this.restaurant || !this.cart.length > 0 || (!this.selectedTime && !this.delivery) || (this.delivery && parseFloat(this.totalPrice) < this.minDeliveryValue) && !this.minDeliveryValue || (!this.minDeliveryValue && this.delivery)) return 
      this.orderModal = true
      this.cartModal = false
    },
    openOrderModalEvent(){
      if(!this.restaurant || !this.cart.length > 0 ) return 
      this.orderModalEvent = true
      this.cartModal = false
    },
    openOrderModalMobileEvent(){
      if(!this.restaurant || !this.cart.length > 0 ) return 
      this.orderActive = true
      this.orderModalMobile = true
    },
    openOrderModalMobile(){
      if(!this.restaurant || !this.cart.length > 0 || (!this.selectedTime && !this.delivery) || (this.delivery && parseFloat(this.totalPrice) < this.minDeliveryValue) && !this.minDeliveryValue || (!this.minDeliveryValue && this.delivery)) return 
      this.orderModalMobile = true
    },
    dateDisabled() {
        return false
    },
    getNextTime(minutes){
      var date = new Date(this.nextTimes.time1.date.getTime() + minutes*60000);
      var payload = {
        date: date,
        time: ("0" + (date.getHours())).slice(-2)+':'+("0" + (date.getMinutes())).slice(-2)
      }
      return payload
    },

    selectTime(index, time){
      this.preTime = index
      this.selectedTime = time.date
      this.timeModal = false
    },

    getNow: function() {
      const today = new Date();
      this.now = new Date();
      const time = ("0" + today.getHours()).slice(-2) +':'+ ("0" + today.getMinutes()).slice(-2)
      const dateTime = time;
      this.timestamp = dateTime;
      if(this.restaurant){
        this.$store.dispatch('checkSlots', {company: this.restaurant._id, date: this.timeString})
      }
    },

    resendCode(){
      if(this.timer > 0) return
      this.$store.dispatch('resendConfirmation', {_id: this.orderState.order._id})
      this.setTimer()
      clearInterval(this.resendTimer);
    },

    confirmOrder(){
      if(this.updating || !this.storedOrder) return
      const payload = {
        _id: this.storedOrder._id,
        change_route: true,
        data: {
          verification_number: this.securityCode
        }
      }

      var index = this.globalCart.findIndex(el => el._id == this.restaurant._id)
      this.globalCart.splice(index, 1)
      this.$store.dispatch('confirmOrder', payload)
    },
    setTimer(){
      this.timer = 120
      var vm = this
      this.resendTimer = setInterval(function(){
        if(vm.timer <= 0){
          clearInterval(vm.resendTimer);
        }
        vm.timer -= 1;
      }, 1000);
    },
    endOrder(){
      this.orderModal = false
      this.cartModal = false
      this.$store.commit('orderState', {})
      var index = this.globalCart.findIndex(el => el._id == this.restaurant._id)
      this.globalCart.splice(index, 1)
      this.cart = []
      this.selectedTime = null
    },

    postOrderEvent(){
      if(!this.order.phone || !this.order.firstname || !this.order.lastname || !this.order.dsgvo_accepted || !this.order.over_sixteen || !this.eventOrder.zipcode || !this.eventOrder.city || !this.eventOrder.street) return
      var testString = this.order.phone.substring(0,3)
      var mobileNumber = this.preNumber + parseInt(this.order.phone, 10)
      if(testString === '+49'){
        mobileNumber = this.order.phone
      }

      var newDate = new Date(this.selectedTime)
      var date = newDate.getFullYear()+'-'+("0" + (newDate.getMonth() + 1)).slice(-2)+'-'+("0" + newDate.getDate()).slice(-2)
      var time = ("0" + newDate.getHours()).slice(-2)+':'+("0" + newDate.getMinutes()).slice(-2)

      var addressData = {
        addressData: {
          locality: this.eventOrder.street+ ', '+this.eventOrder.zipcode+' '+this.eventOrder.city+', Deutschland'
        },
        locality: this.eventOrder.street+ ', '+this.eventOrder.zipcode+' '+this.eventOrder.city+', Deutschland'
      }
      var payload = {
        title: 'Bestellung',
        description: '',
        customer_email: this.order.email,
        customer_phone: mobileNumber,
        customer_firstname: this.order.firstname,
        customer_lastname: this.order.lastname,
        date: date,
        time: time,
        company: this.restaurant._id,
        items: this.cart,
        created: new Date(),
        delivery_time: '2021-04-02T12:00:00.000+00:00',
        price: this.totalPrice,
        delivery_fee: this.deliveryFee,
        addressData: addressData,
        eventOrder: true
      }
      this.$store.dispatch('postOrder', payload)
      this.setTimer()
    },

    postOrder(){
      if(!this.order.phone || !this.order.firstname || !this.order.lastname || !this.order.dsgvo_accepted || (!this.selectedTime && !this.delivery) || (this.delivery && parseFloat(this.totalPrice) < this.minDeliveryValue)) return
      var testString = this.order.phone.substring(0,3)
      var mobileNumber = this.preNumber + parseInt(this.order.phone, 10)
      if(testString === '+49'){
        mobileNumber = this.order.phone
      }

      var newDate = new Date(this.selectedTime)
      var date = newDate.getFullYear()+'-'+("0" + (newDate.getMonth() + 1)).slice(-2)+'-'+("0" + newDate.getDate()).slice(-2)
      var time = ("0" + newDate.getHours()).slice(-2)+':'+("0" + newDate.getMinutes()).slice(-2)

      if(this.delivery){
        var newDateObj = new Date(new Date().getTime() + this.restaurant.actual_delivery_time*60000);
        var roundedMinutes = (((newDateObj.getMinutes() + 7.5)/15 | 0) * 15) % 60;
        if(roundedMinutes == 0 && newDateObj.getMinutes() > 45){
            newDateObj.setHours(newDateObj.getHours() + 1)
        }
        roundedMinutes = ("0" + roundedMinutes).slice(-2)
        
        date = new Date().getFullYear()+'-'+("0" + (new Date().getMonth() + 1)).slice(-2)+'-'+("0" + new Date().getDate()).slice(-2)
        time = ("0" + newDateObj.getHours()).slice(-2)+':'+("0" + roundedMinutes).slice(-2)

      }
      
      var payload = {
        title: 'Bestellung',
        description: '',
        customer_email: this.order.email,
        customer_phone: mobileNumber,
        customer_firstname: this.order.firstname,
        customer_lastname: this.order.lastname,
        date: date,
        time: time,
        company: this.restaurant._id,
        items: this.cart,
        created: new Date(),
        delivery_time: this.selectedTime,
        price: this.totalPrice,
        delivery_fee: this.deliveryFee
      }
      if(this.delivery){
        var dt = new Date();
        payload.addressData = this.adressData_delivery
        payload.delivery_time = dt.setMinutes( dt.getMinutes() + this.restaurant.actual_delivery_time );
      }
      this.$store.dispatch('postOrder', payload)
      this.setTimer()
    },
    openRatingModal(){
      if(!this.restaurant.ratings) return
      if(this.restaurant.ratings.length == 0) return 
      this.ratingModal = true
    },
    windowOpen(){
      window.open('href="' +this.restaurant.contact.phone + '", "_blank"')
    },
    linkOpen(link){
      window.open(link, "_blank")
    },
    getImages(img){
      return process.env.VUE_APP_API_BASEURL + '/' + img
    },
    login(){
      var payload = {
        email: this.form.email,
        password: this.form.password
      }
      this.$store.dispatch('login', payload)
    }, 
    addToCart(item){
      // console.log(item)
      const menuItem = JSON.parse(JSON.stringify(item))
      var vm = this
      if(this.cart.find(el => {
        if(el._id == item._id){
           if(JSON.stringify(el.extras) == JSON.stringify(item.extras) && JSON.stringify(el.variants) == JSON.stringify(item.variants)) return true
        }
      })){
        var found = this.cart.find(el => JSON.stringify(el.extras) == JSON.stringify(item.extras) && JSON.stringify(el.variants) == JSON.stringify(item.variants))
        if(JSON.stringify(found.variants) == JSON.stringify(menuItem.variants) && JSON.stringify(found.extras) == JSON.stringify(menuItem.extras)){
          if(!this.restaurant.event){
            found.amount += 1
          }
          
        }else{
          menuItem.amount = 1
          this.cart.push(menuItem)
        }
        
      }else{
        menuItem.amount = 1
        this.cart.push(menuItem)
      }

      vm.animateCart = true
      setTimeout(function(){ 
        vm.animateCart = false
       }, 500);

    },
    addToCartExtras(item){
      this.extrasItem = item
      this.extrasModal = true
    },
    addItem(item){
      if(this.cart.find(el => el._id == item._id).amount >= 10) return
      this.cart.find(el => el._id == item._id).amount += 1
    },
    subItem(item, index){
      this.cart.find(el => el._id == item._id).amount -= 1
      if(this.cart.find(el => el._id == item._id).amount <= 0){
        this.cart.splice(index, 1)
      }
    },
    addExtra(item){
      if(!item.amount){
        item.amount = 1
      }
      item.amount += 1
    },
    subExtra(item){
      if(!item.amount){
        item.amount = 0
        return
      }

      item.amount -= 1
    }
  }
}
</script>
<style lang="scss">
  .b-calendar-grid-help {
    display: none !important;
  }

  .b-calendar-grid {
    border: none !important;
  }

  .scroll-container-categories {
    overflow: auto;
    white-space:nowrap;
    width: 100%;
    height: 100%;
    cursor : -webkit-grab;
    cursor : -moz-grab;
    cursor : -o-grab;
    cursor : grab;
  }
  .scroll-item {
    cursor: pointer;
    padding: 10px;
    margin-top: 20px;
    background-color: white;
    border-radius: 20px;
    display: inline-block;
    vertical-align:center;
    margin-right:10px;
    margin-left:10px;
    // white-space:normal;
  }

.scroll-container-categories:active {
  cursor : -webkit-grabbing;
  cursor : -moz-grabbing;
  cursor : -o-grabbing;
  cursor : grabbing;
}

#eventModal___BV_modal_outer_ .modal-backdrop{
  opacity: 1 !important;
}
</style>